/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { COINSharedApplicationProtosResponsesStatusResponse } from '@coin/shared/core/util-models';
import { IncentiveDuplicateIncentiveSeasonModel } from '@coin/shared/core/util-models';
import { MeritCommunicationSettingsMeritCommunicationSettingsModel } from '@coin/shared/core/util-models';
import { MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { PositionEvaluationSimulationsPositionEvaluationSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsBudgetBucketModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsBudgetBucketModificationResponseModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsUpdateBudgetBucketModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetBucketsUpdateManyBudgetBucketsModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsBucketComponentModificationResponseModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsBucketComponentsPossibilitiesModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsCreateBucketComponentModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsCreateManyBucketComponentsModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsUpdateBucketComponentModel } from '@coin/shared/core/util-models';
import { SeasonsBudgetComponentsUpdateManyBucketComponentsModel } from '@coin/shared/core/util-models';
import { SeasonsCandidatePoolsCandidatePoolModel } from '@coin/shared/core/util-models';
import { SeasonsCandidatePoolsCreateCandidatePoolModel } from '@coin/shared/core/util-models';
import { SeasonsCandidatePoolsUpdateCandidatePoolModel } from '@coin/shared/core/util-models';
import { SeasonsCommunicationSettingsUpdateCommunicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsCreateEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel } from '@coin/shared/core/util-models';
import { SeasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { SeasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { SeasonsMembersCreateMemberModel } from '@coin/shared/core/util-models';
import { SeasonsMembersEmployeeSeasonOverviewModel } from '@coin/shared/core/util-models';
import { SeasonsMembersMemberModel } from '@coin/shared/core/util-models';
import { SeasonsMembersUpdateMemberModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationSnapshotsOrganisationSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel } from '@coin/shared/core/util-models';
import { SeasonsPlanSettingsCreatePlanSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPlanSettingsPlanSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPlanSettingsUpdatePlanSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPlansCreatePlanModel } from '@coin/shared/core/util-models';
import { SeasonsPlansPlanModel } from '@coin/shared/core/util-models';
import { SeasonsPlansUpdatePlanModel } from '@coin/shared/core/util-models';
import { SeasonsPrioritiesChangeManyPrioritiesModel } from '@coin/shared/core/util-models';
import { SeasonsPublicationSettingsCreatePublicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPublicationSettingsPublicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsPublicationSettingsUpdatePublicationSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsRecordsAssignMissingIndividualIncentiveModel } from '@coin/shared/core/util-models';
import { SeasonsRecordsRecordModel } from '@coin/shared/core/util-models';
import { SeasonsRemEmployeePopulationCreatedResultPagedDto } from '@coin/shared/core/util-models';
import { SeasonsRemExportEmployeePopulationResultDto } from '@coin/shared/core/util-models';
import { SeasonsRemPopulationCreatedResultPagedDto } from '@coin/shared/core/util-models';
import { SeasonsSeasonsCreateSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSeasonsSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSeasonsUpdateSeasonModel } from '@coin/shared/core/util-models';
import { SeasonsSettingsSeasonSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsSettingsSetSeasonSettingsModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationPublicationsPublishSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationPublicationsUnPublishSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsCalculateManySimulationsModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsCalculateSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsCreateSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsUpdateSimulationMembersModel } from '@coin/shared/core/util-models';
import { SeasonsSimulationsUpdateSimulationModel } from '@coin/shared/core/util-models';
import { SeasonsSnapshotsSnapshotModel } from '@coin/shared/core/util-models';
import { SeasonsSnapshotsUpdateSnapshotBenchmarkValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsMembersMemberModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsPlansPlanModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsRecordsRecordModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsSeasonsSeasonModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSeasonsSnapshotsSnapshotModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { SharedRuleEngineRuleSetModel } from '@coin/shared/core/util-models';
import { TransactionStatusOfCalculationStatus } from '@coin/shared/core/util-models';
import { TransactionStatusOfCandidatePoolRecalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfIMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfImportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfMassSimulationCalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfPlanPopulationCreationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfPlanPopulationRecalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfPopulationCreationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSettingsPopulationRecalculationMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSimpleStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfSimulationPublishMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface SeasonsIncentiveAdminServiceAssignKpiDetailsToRecordRecordsRequestParams {
  recordId: string;
  /** Information about the record and kpis */
  seasonsRecordsAssignMissingIndividualIncentiveModel?: SeasonsRecordsAssignMissingIndividualIncentiveModel;
}

export interface SeasonsIncentiveAdminServiceCalculateManySimulationRequestParams {
  seasonId: string;
  seasonsSimulationsCalculateManySimulationsModel?: SeasonsSimulationsCalculateManySimulationsModel;
}

export interface SeasonsIncentiveAdminServiceCalculateSimulationRequestParams {
  seasonId: string;
  seasonsSimulationsCalculateSimulationModel?: SeasonsSimulationsCalculateSimulationModel;
}

export interface SeasonsIncentiveAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams {
  simulationId: string;
  seasonsPrioritiesChangeManyPrioritiesModel?: SeasonsPrioritiesChangeManyPrioritiesModel;
}

export interface SeasonsIncentiveAdminServiceChangePrioritiesPlansRequestParams {
  seasonsPrioritiesChangeManyPrioritiesModel?: SeasonsPrioritiesChangeManyPrioritiesModel;
}

export interface SeasonsIncentiveAdminServiceCreateBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsCreateBucketComponentModel?: SeasonsBudgetComponentsCreateBucketComponentModel;
}

export interface SeasonsIncentiveAdminServiceCreateCandidatePoolsRequestParams {
  seasonsCandidatePoolsCreateCandidatePoolModel?: SeasonsCandidatePoolsCreateCandidatePoolModel;
}

export interface SeasonsIncentiveAdminServiceCreateEmployeeSnapshotsRequestParams {
  seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel?: SeasonsEmployeeSnapshotsCreateEmployeeSnapshotModel;
}

export interface SeasonsIncentiveAdminServiceCreateInformationVisibilitySettingsRequestParams {
  simulationId: string;
  seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel?: SeasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel;
}

export interface SeasonsIncentiveAdminServiceCreateManyBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsCreateManyBucketComponentsModel?: SeasonsBudgetComponentsCreateManyBucketComponentsModel;
}

export interface SeasonsIncentiveAdminServiceCreateMembersRequestParams {
  seasonsMembersCreateMemberModel?: SeasonsMembersCreateMemberModel;
}

export interface SeasonsIncentiveAdminServiceCreateOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel?: SeasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel;
}

export interface SeasonsIncentiveAdminServiceCreatePlanSettingsRequestParams {
  planId: string;
  seasonsPlanSettingsCreatePlanSettingsModel?: SeasonsPlanSettingsCreatePlanSettingsModel;
}

export interface SeasonsIncentiveAdminServiceCreatePlansRequestParams {
  seasonsPlansCreatePlanModel?: SeasonsPlansCreatePlanModel;
}

export interface SeasonsIncentiveAdminServiceCreatePublicationSettingsRequestParams {
  seasonId: string;
  seasonsPublicationSettingsCreatePublicationSettingsModel?: SeasonsPublicationSettingsCreatePublicationSettingsModel;
}

export interface SeasonsIncentiveAdminServiceCreateSeasonsRequestParams {
  seasonsSeasonsCreateSeasonModel?: SeasonsSeasonsCreateSeasonModel;
}

export interface SeasonsIncentiveAdminServiceCreateSimulationRequestParams {
  seasonsSimulationsCreateSimulationModel?: SeasonsSimulationsCreateSimulationModel;
}

export interface SeasonsIncentiveAdminServiceDeleteBudgetComponentsRequestParams {
  budgetBucketId: string;
}

export interface SeasonsIncentiveAdminServiceDeleteCandidatePoolsRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceDeleteEmployeeSnapshotsRequestParams {
  snapshotId: string;
}

export interface SeasonsIncentiveAdminServiceDeleteMembersRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceDeleteOrganisationInformationSnapshotsRequestParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceDeletePlanSettingsRequestParams {
  id: string;
  planId: string;
}

export interface SeasonsIncentiveAdminServiceDeletePlansRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceDeleteSeasonsRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceDeleteSimulationSettingsRequestParams {
  id: string;
  seasonId: string;
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility';
}

export interface SeasonsIncentiveAdminServiceDuplicateSeasonsRequestParams {
  id: string;
  incentiveDuplicateIncentiveSeasonModel?: IncentiveDuplicateIncentiveSeasonModel;
}

export interface SeasonsIncentiveAdminServiceExportEmployeeCandidatesRequestParams {
  seasonId: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  recordIds?: Array<string>;
  state?: 'Open' | 'Done';
  filename?: string;
}

export interface SeasonsIncentiveAdminServiceExportOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  fileName?: string;
}

export interface SeasonsIncentiveAdminServiceExportPlanWithMissingIndividualValuesRequestParams {
  seasonId?: string;
}

export interface SeasonsIncentiveAdminServiceExportSeasonPopulationsRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceGetBudgetBucketsRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceGetBudgetBucketsPlansRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceGetByIdRecordsRequestParams {
  /** id of the record entity */
  recordId: string;
}

export interface SeasonsIncentiveAdminServiceGetEmployeeSnapshotsRequestParams {
  snapshotId: string;
}

export interface SeasonsIncentiveAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceGetMembersRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceGetMySeasonRecordsSeasonsRequestParams {
  id: string;
  memberId?: string;
  gid?: string;
}

export interface SeasonsIncentiveAdminServiceGetOfSeasonPublicationSettingsRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceGetOrganisationInformationSnapshotsRequestParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceGetOrganisationSnapshotsRequestParams {
  seasonId: string;
  id: string;
}

export interface SeasonsIncentiveAdminServiceGetPlanPopulationPlansRequestParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceGetPlanRecordsPlansRequestParams {
  id: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceGetPlanSettingsRequestParams {
  planId: string;
}

export interface SeasonsIncentiveAdminServiceGetPlansRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceGetPublicationSettingsRequestParams {
  id: string;
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceGetRecordsRequestParams {
  /**  */
  seasonId: string;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId2?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsIncentiveAdminServiceGetSeasonCommunicationSettingsRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams {
  gid?: string;
}

export interface SeasonsIncentiveAdminServiceGetSeasonRecordsSeasonsRequestParams {
  id: string;
  queryId?: string;
  queryGid?: Array<string>;
  queryFirstName?: Array<string>;
  queryLastName?: Array<string>;
  queryCountry?: Array<string>;
  queryAre?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgClusterNodeName?: Array<string>;
  queryState?: Array<'Active' | 'Draft' | 'Outdated' | 'Irrelevant'>;
  queryPlanName?: Array<string>;
  queryStartDate?: string;
  queryEndDate?: string;
  queryAssignmentId?: string;
  queryLetterType?:
    | 'Other'
    | 'AdherenceLetter'
    | 'TargetAgreementForm'
    | 'TargetAchievementForm'
    | 'MeritAllocation'
    | 'SpecialRecognitionLetter'
    | 'RestructuringCalculation'
    | 'RestructuringLetter';
  queryProcessStates?: Array<
    | 'None'
    | 'Open'
    | 'TafCreated'
    | 'TafPublished'
    | 'ReadyForCalculation'
    | 'Calculated'
    | 'Frozen'
    | 'AchievementLetterCreated'
    | 'AchievementLetterPublished'
  >;
  queryRecordCommunicationStates?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoLetterRequired'
  >;
  queryWorkflow?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryTemplate?: Array<string>;
  queryIsDesignReady?: boolean;
  queryPayoutDate?: string;
  queryPayoutState?: Array<
    'StandardPayout' | 'FullPayout' | 'DefinedPayoutEndOfFiscalYear' | 'NoPayout' | 'Irrelevant'
  >;
  queryLineManagerName?: string;
  queryLineManagerGid?: Array<string>;
  querySeasonId?: string;
  queryWorkflowInstanceState?: Array<
    | 'None'
    | 'InManagerReview'
    | 'ManagerValidated'
    | 'ReviewPeriodClosed'
    | 'Transferred'
    | 'ManagerRejected'
    | 'InAllocation'
    | 'AllocationFinished'
  >;
  queryMultiplier?: number;
  queryOverallTargetAchievement?: number;
  queryPayoutAmount?: number;
  queryPayoutCurrency?: Array<string>;
  queryIppAchievementValue?: string;
  queryIncentivePaymentType?: Array<string>;
  queryContractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  queryMeasurementDate?: string;
  queryMeritTitle?: Array<string>;
  queryEquityTitle?: Array<string>;
  queryEquitySubTitle?: Array<string>;
  queryManuallyChanged?: Array<'None' | 'Activated' | 'Deactivated'>;
  queryNewHire?: Array<'None' | 'Approved' | 'Reviewed' | 'ForReview' | 'Rejected'>;
  queryPromotion?: Array<'None' | 'Requested' | 'InProgress' | 'Rejected' | 'Finalized' | 'RequestedCb'>;
  queryTermination?: Array<'None' | 'ForReview' | 'Rejected' | 'Finalized'>;
  queryPopulationChange?: Array<'None' | 'MeritPopulation' | 'EquityPopulation'>;
  queryLineManagerFirstName?: Array<string>;
  queryLineManagerLastName?: Array<string>;
  queryCompanyManagerFirstName?: Array<string>;
  queryCompanyManagerGid?: Array<string>;
  queryCompanyManagerLastName?: Array<string>;
  queryTemplateName?: Array<string>;
  queryWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryAutoApprove?: boolean;
  queryApprovalRequired?: boolean;
  queryLetterState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryProcessState?: Array<
    | 'None'
    | 'Created'
    | 'InManagerReview'
    | 'InEmployeeReview'
    | 'Published'
    | 'ManagerRejected'
    | 'EmployeeRejected'
    | 'NoTafRequired'
    | 'InBusinessPartnerReview'
    | 'BusinessPartnerRejected'
  >;
  queryExportState?: Array<'Open' | 'Done'>;
  queryPayrollState?: Array<'Open' | 'Done'>;
  queryMeritRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryApprovedByCompanyManager?: boolean;
  queryAllocationWorkflowType?: Array<
    | 'EmployeeConfirmation'
    | 'EmployeeSignature'
    | 'ManagerConfirmationEmployeeConfirmation'
    | 'ManagerConfirmationEmployeeSignature'
    | 'ManagerSignatureEmployeeConfirmation'
    | 'ManagerSignatureEmployeeSignature'
    | 'ManagerConfirmationEmployeeNoActionNeeded'
    | 'NoActionNeeded'
    | 'AllocationByInCompanyManagerInvisibleForLineManager'
    | 'AllocationByInCompanyManagerVisibleForLineManager'
    | 'AllocationByLineManagerApprovalByInCompanyManager'
    | 'AllocationByLineManagerVisibleForInCompanyManager'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeSignature'
    | 'BusinessPartnerConfirmationManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerConfirmationManagerSignatureEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeSignature'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeConfirmation'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeSignature'
    | 'BusinessPartnerSignatureManagerConfirmationEmployeeNoActionNeeded'
    | 'BusinessPartnerSignatureManagerSignatureEmployeeNoActionNeeded'
  >;
  queryReadyToPayroll?: boolean;
  queryEquityRelevancy?: Array<'Relevant' | 'Excluded' | 'NoIncrease'>;
  queryHasOtpIncrease?: boolean;
  queryIsOtpOnly?: boolean;
  queryPlanTitle?: Array<string>;
  queryLocalCurrency?: Array<string>;
  queryProposalAmount?: number;
  queryProposalAmountInEuro?: number;
  queryProposalDate?: string;
  queryProposalState?: Array<'Unknown' | 'Pending' | 'Approved' | 'AutoApproved' | 'Rejected'>;
  querySpecialPaymentReason?: Array<'Unknown' | 'SpecialProjectsInvolvement' | 'TemporaryEnlargedScope'>;
  querySpecialPaymentCompensationType?: Array<'Unknown' | 'Cash' | 'Equity'>;
  queryTemplateLetterName?: Array<string>;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminServiceGetSeasonSettingsRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceGetSeasonsRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceGetSimulationRequestParams {
  simulationId: string;
}

export interface SeasonsIncentiveAdminServiceGetSnapshotSeasonsRequestParams {
  id: string;
  employeeId: string;
}

export interface SeasonsIncentiveAdminServiceGetTreeOrganisationSnapshotsRequestParams {
  seasonId: string;
  parentOrgCode?: string;
}

export interface SeasonsIncentiveAdminServicePartialUpdateEmployeeSnapshotsRequestParams {
  snapshotId: string;
  seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel?: SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel;
}

export interface SeasonsIncentiveAdminServicePrePublishSimulationPublicationsRequestParams {
  simulationId: string;
  positionName?: Array<string>;
  orgCode?: Array<string>;
  orgCodeStartsWith?: Array<string>;
  orgLevel?: Array<number>;
  orgSize?: Array<number>;
  mercerJobCode?: Array<string>;
  positionClass?: Array<number>;
  newPositionClass?: Array<number>;
  originalProposedPositionClass?: Array<number>;
  positionType?: Array<string>;
  countryIsoCode?: Array<string>;
  incumbentGid?: Array<string>;
  incumbentFirstName?: Array<string>;
  incumbentLastName?: Array<string>;
  incumbentCountryPlaceOfAction?: Array<string>;
  validationManagerId?: Array<string>;
  validationManagerGid?: Array<string>;
  validationManagerFirstName?: Array<string>;
  validationManagerLastName?: Array<string>;
  validationState?: Array<string>;
  placementState?: Array<string>;
  newHireState?: Array<string>;
  isLocked?: Array<boolean>;
  mercerJobFamily?: Array<string>;
  mercerJobSpecialization?: Array<string>;
  mercerJobSubFamily?: Array<string>;
  incumbentAre?: Array<string>;
  tag?: Array<string>;
  wasPromoted?: Array<boolean>;
  isTransferred?: Array<boolean>;
  seasonsSimulationPublicationsPublishSimulationModel?: SeasonsSimulationPublicationsPublishSimulationModel;
}

export interface SeasonsIncentiveAdminServicePublishSimulationPublicationsRequestParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  seasonsSimulationPublicationsPublishSimulationModel?: SeasonsSimulationPublicationsPublishSimulationModel;
}

export interface SeasonsIncentiveAdminServiceQueryCandidatePoolsRequestParams {
  seasonId?: string;
}

export interface SeasonsIncentiveAdminServiceQueryEmployeeCandidatesRequestParams {
  seasonId?: string;
  queryGid?: string;
  queryFirstname?: string;
  queryLastname?: string;
  queryPAOrgCode?: Array<string>;
  queryCandidatePoolTitle?: Array<string>;
  queryOrgCode?: string;
  queryGender?: Array<'Male' | 'Female' | 'Undefined'>;
  queryOrgLevel?: Array<number>;
  queryMercerPositionClass?: Array<number>;
  queryIsPlaced?: boolean;
  queryIsShortlisted?: boolean;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface SeasonsIncentiveAdminServiceQueryEmployeeSnapshotsRequestParams {
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams {
  targetProperty?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
  seasonId?: string;
  pagingPage?: number;
  pagingSize?: number;
  gid?: string;
  firstname?: string;
  lastname?: string;
  pAOrgCode?: Array<string>;
  candidatePoolTitle?: Array<string>;
  orgCode?: string;
  gender?: Array<'Male' | 'Female' | 'Undefined'>;
  orgLevel?: Array<number>;
  mercerPositionClass?: Array<number>;
  isPlaced?: boolean;
  isShortlisted?: boolean;
}

export interface SeasonsIncentiveAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams {
  seasonId: string;
  targetProperty?: 0;
  orgCode?: string;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceQueryFieldValuesRecordsRequestParams {
  targetProperty: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17;
  memberId?: string;
  gid?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  country?: Array<string>;
  are?: Array<string>;
  orgCode?: Array<string>;
  state?: Array<string>;
  planName?: Array<string>;
  startDate?: string;
  endDate?: string;
  assignmentId?: string;
  isDesignReady?: boolean;
  letterState?: Array<string>;
  payoutState?: Array<string>;
  template?: string;
  workflow?: string;
  seasonId?: string;
  workflowInstanceState?: Array<string>;
  lineManagerName?: string;
  lineManagerGid?: Array<string>;
  lineManagerPositionClass?: number;
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  orgCode?: Array<string>;
  orgName?: Array<string>;
  orgSize?: number;
  revenue?: number;
  headCount?: number;
  revenueOrgSize?: number;
  headCountOrgSize?: number;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
}

export interface SeasonsIncentiveAdminServiceQueryInformationVisibilitySettingsRequestParams {
  simulationId: string;
  queryTargetProperty?: 0 | 1 | 2 | 3;
  queryTargetTypeString?: string;
  querySimulationId?: string;
  queryPriority?: number;
  queryTitle?: string;
  queryAffectedCount?: number;
  queryType?: 'General' | 'Default';
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminServiceQueryMembersRequestParams {
  page?: number;
  size?: number;
}

export interface SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsRequestParams {
  seasonId: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: string;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams {
  seasonId?: string;
  meritSeasonId?: string;
  search?: string;
  directs?: boolean;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  impersonatedEmployee?: string;
}

export interface SeasonsIncentiveAdminServiceQueryParentsOrganisationSnapshotsRequestParams {
  seasonId: string;
  seasonId2: string;
  querySeasonId?: string;
  queryOrganisationId?: string;
  queryOrgCode?: string;
  queryOrgLevel?: number;
  queryParentOrgCode?: string;
  queryHeadId?: string;
  queryHeadGid?: string;
  queryHeadName?: string;
  queryPositionName?: string;
  queryAdditionalLineOne?: string;
  queryAdditionalLineTwo?: string;
  queryAdditionalLineThree?: string;
  queryAdditionalLineFour?: string;
  queryOrgName?: string;
  queryOrgType?: string;
  queryOrgLevelA?: string;
  queryOrgLevelB?: string;
  queryOrgLevelC?: string;
  queryOrgLevelD?: string;
  queryNumberOfEmployees?: number;
  queryHeadFirstname?: string;
  queryHeadLastname?: string;
  queryHeadPAOrgCode?: string;
  queryHeadPlaceOfAction?: string;
  queryHeadMercerJobCode?: string;
  queryHeadMercerPositionClass?: number;
  queryHeadManagementGroup?: string;
  queryOrgSize?: number;
  queryRevenue?: number;
  queryHeadCount?: number;
  queryRevenueOrgSize?: number;
  queryHeadCountOrgSize?: number;
  queryShowOrganisationsWithoutOrgInfos?: boolean;
}

export interface SeasonsIncentiveAdminServiceQueryPlanWithMissingIndividualValuesRequestParams {
  seasonId?: string;
  queryKpiId?: string;
  queryAssignmentId?: string;
  queryOrgClusterNodeName?: string;
  queryGid?: string;
  queryLastname?: string;
  queryFirstname?: string;
  queryCountry?: string;
  queryOrgCode?: string;
  queryRecordStartdate?: string;
  queryPlanName?: string;
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
}

export interface SeasonsIncentiveAdminServiceQueryPlansRequestParams {
  page?: number;
  size?: number;
  seasonId?: string;
}

export interface SeasonsIncentiveAdminServiceQuerySeasonsRequestParams {
  page?: number;
  size?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  seasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  simulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
  queryManagerEndDateAt?: string;
  queryPartnerEndDateAt?: string;
  querySeasonType?: Array<
    | 'Unknown'
    | 'SOG'
    | 'GBR'
    | 'Merit'
    | 'IncentiveV2'
    | 'SpecialPaymentCash'
    | 'SpecialPaymentEquity'
    | 'PositionEvaluation'
    | 'Restructuring'
  >;
  querySimulationState?: Array<
    | 'Created'
    | 'Edited'
    | 'Simulating'
    | 'Simulated'
    | 'RecalculationRequired'
    | 'Ready'
    | 'Frozen'
    | 'Recalculating'
    | 'InAllocation'
    | 'PrePublished'
    | 'Calculating'
    | 'CalculationRequired'
    | 'Calculated'
    | 'Published'
    | 'UpdatingData'
  >;
}

export interface SeasonsIncentiveAdminServiceQuerySimulationRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams {
  simulationId: string;
  parentSettingId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility';
}

export interface SeasonsIncentiveAdminServiceRecalculatePlanPopulationsRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams {
  simulationId: string;
  settingsType?:
    | 'Merit'
    | 'Equity'
    | 'EquitySub'
    | 'Validation'
    | 'Placement'
    | 'ValidationHr'
    | 'PlacementHr'
    | 'Other'
    | 'NewHirePlan'
    | 'NewHireMerit'
    | 'NewHireEquity'
    | 'NewHireEquitySub'
    | 'IndividualMultiplier'
    | 'InformationVisibility';
}

export interface SeasonsIncentiveAdminServiceSavePlanPopulationsRequestParams {
  id: string;
}

export interface SeasonsIncentiveAdminServiceSaveSeasonPopulationsRequestParams {
  seasonId: string;
}

export interface SeasonsIncentiveAdminServiceSimulatePlanPopulationsRequestParams {
  id: string;
  page?: number;
  size?: number;
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface SeasonsIncentiveAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams {
  settingsId: string;
  simulationId: string;
  page?: number;
  size?: number;
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface SeasonsIncentiveAdminServiceSimulateSeasonPopulationsRequestParams {
  seasonId: string;
  page?: number;
  size?: number;
  _export?: boolean;
  sharedRuleEngineRuleSetModel?: SharedRuleEngineRuleSetModel;
}

export interface SeasonsIncentiveAdminServiceUnPrePublishSimulationPublicationsRequestParams {
  simulationId: string;
}

export interface SeasonsIncentiveAdminServiceUnPublishSimulationPublicationsRequestParams {
  simulationId: string;
  queryPositionName?: Array<string>;
  queryOrgCode?: Array<string>;
  queryOrgCodeStartsWith?: Array<string>;
  queryOrgLevel?: Array<number>;
  queryOrgSize?: Array<number>;
  queryMercerJobCode?: Array<string>;
  queryPositionClass?: Array<number>;
  queryNewPositionClass?: Array<number>;
  queryOriginalProposedPositionClass?: Array<number>;
  queryPositionType?: Array<string>;
  queryCountryIsoCode?: Array<string>;
  queryIncumbentGid?: Array<string>;
  queryIncumbentFirstName?: Array<string>;
  queryIncumbentLastName?: Array<string>;
  queryIncumbentCountryPlaceOfAction?: Array<string>;
  queryValidationManagerId?: Array<string>;
  queryValidationManagerGid?: Array<string>;
  queryValidationManagerFirstName?: Array<string>;
  queryValidationManagerLastName?: Array<string>;
  queryValidationState?: Array<string>;
  queryPlacementState?: Array<string>;
  queryNewHireState?: Array<string>;
  queryIsLocked?: Array<boolean>;
  queryMercerJobFamily?: Array<string>;
  queryMercerJobSpecialization?: Array<string>;
  queryMercerJobSubFamily?: Array<string>;
  queryIncumbentAre?: Array<string>;
  queryTag?: Array<string>;
  queryWasPromoted?: Array<boolean>;
  queryIsTransferred?: Array<boolean>;
  seasonsSimulationPublicationsUnPublishSimulationModel?: SeasonsSimulationPublicationsUnPublishSimulationModel;
}

export interface SeasonsIncentiveAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams {
  seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel?: SeasonsSnapshotsUpdateSnapshotBenchmarkValuesModel;
}

export interface SeasonsIncentiveAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsUpdateManyBucketComponentsModel?: SeasonsBudgetComponentsUpdateManyBucketComponentsModel;
}

export interface SeasonsIncentiveAdminServiceUpdateBucketComponentBudgetComponentsRequestParams {
  budgetBucketId: string;
  seasonsBudgetComponentsUpdateBucketComponentModel?: SeasonsBudgetComponentsUpdateBucketComponentModel;
}

export interface SeasonsIncentiveAdminServiceUpdateBudgetBucketsRequestParams {
  id: string;
  seasonsBudgetBucketsUpdateBudgetBucketModel?: SeasonsBudgetBucketsUpdateBudgetBucketModel;
}

export interface SeasonsIncentiveAdminServiceUpdateCandidatePoolsRequestParams {
  id: string;
  seasonsCandidatePoolsUpdateCandidatePoolModel?: SeasonsCandidatePoolsUpdateCandidatePoolModel;
}

export interface SeasonsIncentiveAdminServiceUpdateEmployeeSnapshotsRequestParams {
  seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel?: SeasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel;
}

export interface SeasonsIncentiveAdminServiceUpdateInformationVisibilitySettingsRequestParams {
  settingsId: string;
  simulationId: string;
  seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel?: SeasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel;
}

export interface SeasonsIncentiveAdminServiceUpdateManyBudgetBucketsRequestParams {
  seasonsBudgetBucketsUpdateManyBudgetBucketsModel?: SeasonsBudgetBucketsUpdateManyBudgetBucketsModel;
}

export interface SeasonsIncentiveAdminServiceUpdateMembersRequestParams {
  seasonsMembersUpdateMemberModel?: SeasonsMembersUpdateMemberModel;
}

export interface SeasonsIncentiveAdminServiceUpdateOrganisationInformationSnapshotsRequestParams {
  seasonId: string;
  id: string;
  seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel?: SeasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel;
}

export interface SeasonsIncentiveAdminServiceUpdatePlanSettingsRequestParams {
  id: string;
  planId: string;
  seasonsPlanSettingsUpdatePlanSettingsModel?: SeasonsPlanSettingsUpdatePlanSettingsModel;
}

export interface SeasonsIncentiveAdminServiceUpdatePlansRequestParams {
  id: string;
  seasonsPlansUpdatePlanModel?: SeasonsPlansUpdatePlanModel;
}

export interface SeasonsIncentiveAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams {
  seasonId: string;
  seasonsPublicationSettingsUpdatePublicationSettingsModel?: SeasonsPublicationSettingsUpdatePublicationSettingsModel;
}

export interface SeasonsIncentiveAdminServiceUpdateSeasonCommunicationSettingsRequestParams {
  seasonId: string;
  seasonsCommunicationSettingsUpdateCommunicationSettingsModel?: SeasonsCommunicationSettingsUpdateCommunicationSettingsModel;
}

export interface SeasonsIncentiveAdminServiceUpdateSeasonSettingsRequestParams {
  seasonsSettingsSetSeasonSettingsModel?: SeasonsSettingsSetSeasonSettingsModel;
}

export interface SeasonsIncentiveAdminServiceUpdateSeasonsRequestParams {
  seasonsSeasonsUpdateSeasonModel?: SeasonsSeasonsUpdateSeasonModel;
}

export interface SeasonsIncentiveAdminServiceUpdateSimulationRequestParams {
  simulationId: string;
  seasonsSimulationsUpdateSimulationModel?: SeasonsSimulationsUpdateSimulationModel;
}

export interface SeasonsIncentiveAdminServiceUpdateSimulationMembersSimulationRequestParams {
  seasonId: string;
  simulationId: string;
  seasonsSimulationsUpdateSimulationMembersModel?: SeasonsSimulationsUpdateSimulationMembersModel;
}

@Injectable({
  providedIn: 'root'
})
export class SeasonsIncentiveAdminService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Assigns a Kpi Detail to given Record
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public assignKpiDetailsToRecordRecords(
    requestParameters?: SeasonsIncentiveAdminServiceAssignKpiDetailsToRecordRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: SeasonsIncentiveAdminServiceAssignKpiDetailsToRecordRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: SeasonsIncentiveAdminServiceAssignKpiDetailsToRecordRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public assignKpiDetailsToRecordRecords(
    requestParameters?: SeasonsIncentiveAdminServiceAssignKpiDetailsToRecordRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    if (recordId === null || recordId === undefined) {
      throw new Error(
        'Required parameter recordId was null or undefined when calling assignKpiDetailsToRecordRecords.'
      );
    }
    const seasonsRecordsAssignMissingIndividualIncentiveModel =
      requestParameters?.seasonsRecordsAssignMissingIndividualIncentiveModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/individual-values`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsRecordsAssignMissingIndividualIncentiveModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public calculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateManySimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfCalculationStatus>;
  public calculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateManySimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfCalculationStatus>>;
  public calculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateManySimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfCalculationStatus>>;
  public calculateManySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateManySimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling calculateManySimulation.');
    }
    const seasonsSimulationsCalculateManySimulationsModel =
      requestParameters?.seasonsSimulationsCalculateManySimulationsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/calculate`;
    return this.httpClient.request<TransactionStatusOfCalculationStatus>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCalculateManySimulationsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public calculateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfMassSimulationCalculationMetadata>;
  public calculateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public calculateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfMassSimulationCalculationMetadata>>;
  public calculateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCalculateSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling calculateSimulation.');
    }
    const seasonsSimulationsCalculateSimulationModel = requestParameters?.seasonsSimulationsCalculateSimulationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/mass-calculate`;
    return this.httpClient.request<TransactionStatusOfMassSimulationCalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCalculateSimulationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<COINSharedApplicationProtosResponsesStatusResponse>;
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<COINSharedApplicationProtosResponsesStatusResponse>>;
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<COINSharedApplicationProtosResponsesStatusResponse>>;
  public changePrioritiesInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling changePrioritiesInformationVisibilitySettings.'
      );
    }
    const seasonsPrioritiesChangeManyPrioritiesModel = requestParameters?.seasonsPrioritiesChangeManyPrioritiesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/priorities`;
    return this.httpClient.request<COINSharedApplicationProtosResponsesStatusResponse>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPrioritiesChangeManyPrioritiesModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public changePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public changePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public changePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public changePrioritiesPlans(
    requestParameters?: SeasonsIncentiveAdminServiceChangePrioritiesPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const seasonsPrioritiesChangeManyPrioritiesModel = requestParameters?.seasonsPrioritiesChangeManyPrioritiesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/priorities`;
    return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPrioritiesChangeManyPrioritiesModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public createBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error('Required parameter budgetBucketId was null or undefined when calling createBudgetComponents.');
    }
    const seasonsBudgetComponentsCreateBucketComponentModel =
      requestParameters?.seasonsBudgetComponentsCreateBucketComponentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsCreateBucketComponentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceCreateCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsCandidatePoolsCandidatePoolModel>;
  public createCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceCreateCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsCandidatePoolsCandidatePoolModel>>;
  public createCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceCreateCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsCandidatePoolsCandidatePoolModel>>;
  public createCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceCreateCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsCandidatePoolsCreateCandidatePoolModel =
      requestParameters?.seasonsCandidatePoolsCreateCandidatePoolModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools`;
    return this.httpClient.request<SeasonsCandidatePoolsCandidatePoolModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsCandidatePoolsCreateCandidatePoolModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public createEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public createEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public createEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel =
      requestParameters?.seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsEmployeeSnapshotsCreateEmployeeSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>;
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public createInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreateInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling createInformationVisibilitySettings.'
      );
    }
    const seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel =
      requestParameters?.seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`;
    return this.httpClient.request<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsInformationVisibilitySettingsCreateInformationVisibilitySettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateManyBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public createManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateManyBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateManyBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public createManyBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceCreateManyBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling createManyBudgetComponents.'
      );
    }
    const seasonsBudgetComponentsCreateManyBucketComponentsModel =
      requestParameters?.seasonsBudgetComponentsCreateManyBucketComponentsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsCreateManyBucketComponentsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createMembers(
    requestParameters?: SeasonsIncentiveAdminServiceCreateMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersMemberModel>;
  public createMembers(
    requestParameters?: SeasonsIncentiveAdminServiceCreateMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersMemberModel>>;
  public createMembers(
    requestParameters?: SeasonsIncentiveAdminServiceCreateMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersMemberModel>>;
  public createMembers(
    requestParameters?: SeasonsIncentiveAdminServiceCreateMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsMembersCreateMemberModel = requestParameters?.seasonsMembersCreateMemberModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members`;
    return this.httpClient.request<SeasonsMembersMemberModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsMembersCreateMemberModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public createOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceCreateOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling createOrganisationInformationSnapshots.'
      );
    }
    const seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel =
      requestParameters?.seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`;
    return this.httpClient.request<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsOrganisationInformationSnapshotsCreateOrganisationInformationSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlanSettingsPlanSettingsModel>;
  public createPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlanSettingsPlanSettingsModel>>;
  public createPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlanSettingsPlanSettingsModel>>;
  public createPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling createPlanSettings.');
    }
    const seasonsPlanSettingsCreatePlanSettingsModel = requestParameters?.seasonsPlanSettingsCreatePlanSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`;
    return this.httpClient.request<SeasonsPlanSettingsPlanSettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPlanSettingsCreatePlanSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPlans(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlansPlanModel>;
  public createPlans(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlansPlanModel>>;
  public createPlans(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlansPlanModel>>;
  public createPlans(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsPlansCreatePlanModel = requestParameters?.seasonsPlansCreatePlanModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans`;
    return this.httpClient.request<SeasonsPlansPlanModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPlansCreatePlanModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public createPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public createPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public createPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceCreatePublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling createPublicationSettings.');
    }
    const seasonsPublicationSettingsCreatePublicationSettingsModel =
      requestParameters?.seasonsPublicationSettingsCreatePublicationSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPublicationSettingsCreatePublicationSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSeasonsSeasonModel>;
  public createSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSeasonsSeasonModel>>;
  public createSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSeasonsSeasonModel>>;
  public createSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSeasonsCreateSeasonModel = requestParameters?.seasonsSeasonsCreateSeasonModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons`;
    return this.httpClient.request<SeasonsSeasonsSeasonModel>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsSeasonsCreateSeasonModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfIMetadata>;
  public createSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public createSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public createSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceCreateSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSimulationsCreateSimulationModel = requestParameters?.seasonsSimulationsCreateSimulationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations`;
    return this.httpClient.request<TransactionStatusOfIMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsCreateSimulationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error('Required parameter budgetBucketId was null or undefined when calling deleteBudgetComponents.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCandidatePools.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error('Required parameter snapshotId was null or undefined when calling deleteEmployeeSnapshots.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteMembers(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteMembers(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteMembers(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteMembers(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteMembers.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public deleteOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteOrganisationInformationSnapshots.'
      );
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling deleteOrganisationInformationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<boolean>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePlanSettings.');
    }
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling deletePlanSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePlans(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePlans(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePlans(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePlans(
    requestParameters?: SeasonsIncentiveAdminServiceDeletePlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSimulationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSimulationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSimulationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteSimulationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceDeleteSimulationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteSimulationSettings.');
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling deleteSimulationSettings.');
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error('Required parameter simulationId was null or undefined when calling deleteSimulationSettings.');
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public duplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDuplicateSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimpleStatusMetadata>;
  public duplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDuplicateSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimpleStatusMetadata>>;
  public duplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDuplicateSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimpleStatusMetadata>>;
  public duplicateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceDuplicateSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling duplicateSeasons.');
    }
    const incentiveDuplicateIncentiveSeasonModel = requestParameters?.incentiveDuplicateIncentiveSeasonModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/duplicate`;
    return this.httpClient.request<TransactionStatusOfSimpleStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: incentiveDuplicateIncentiveSeasonModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceExportEmployeeCandidatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceExportEmployeeCandidatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceExportEmployeeCandidatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceExportEmployeeCandidatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling exportEmployeeCandidates.');
    }
    const queryGid = requestParameters?.queryGid;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryPAOrgCode = requestParameters?.queryPAOrgCode;
    const queryCandidatePoolTitle = requestParameters?.queryCandidatePoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryGender = requestParameters?.queryGender;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryMercerPositionClass = requestParameters?.queryMercerPositionClass;
    const queryIsPlaced = requestParameters?.queryIsPlaced;
    const queryIsShortlisted = requestParameters?.queryIsShortlisted;
    const recordIds = requestParameters?.recordIds;
    const state = requestParameters?.state;
    const filename = requestParameters?.filename;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryPAOrgCode) {
      queryPAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PAOrgCode');
      });
    }
    if (queryCandidatePoolTitle) {
      queryCandidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CandidatePoolTitle'
        );
      });
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryGender) {
      queryGender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gender');
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryMercerPositionClass) {
      queryMercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerPositionClass'
        );
      });
    }
    if (queryIsPlaced !== undefined && queryIsPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsPlaced, 'Query.IsPlaced');
    }
    if (queryIsShortlisted !== undefined && queryIsShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsShortlisted,
        'Query.IsShortlisted'
      );
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (recordIds) {
      recordIds.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RecordIds');
      });
    }
    if (state !== undefined && state !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>state, 'State');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-candidates/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceExportOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling exportOrganisationInformationSnapshots.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgName = requestParameters?.orgName;
    const orgSize = requestParameters?.orgSize;
    const revenue = requestParameters?.revenue;
    const headCount = requestParameters?.headCount;
    const revenueOrgSize = requestParameters?.revenueOrgSize;
    const headCountOrgSize = requestParameters?.headCountOrgSize;
    const fileName = requestParameters?.fileName;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgName) {
      orgName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgName');
      });
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (revenue !== undefined && revenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenue, 'Revenue');
    }
    if (headCount !== undefined && headCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>headCount, 'HeadCount');
    }
    if (revenueOrgSize !== undefined && revenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenueOrgSize, 'RevenueOrgSize');
    }
    if (headCountOrgSize !== undefined && headCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headCountOrgSize,
        'HeadCountOrgSize'
      );
    }
    if (fileName !== undefined && fileName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>fileName, 'fileName');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceExportPlanWithMissingIndividualValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/missing-individual-values`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceExportSeasonPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRemExportEmployeePopulationResultDto>;
  public exportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceExportSeasonPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRemExportEmployeePopulationResultDto>>;
  public exportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceExportSeasonPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRemExportEmployeePopulationResultDto>>;
  public exportSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceExportSeasonPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling exportSeasonPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/export-population`;
    return this.httpClient.request<SeasonsRemExportEmployeePopulationResultDto>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetBucketsBudgetBucketModel>;
  public getBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetBucketsBudgetBucketModel>>;
  public getBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetBucketsBudgetBucketModel>>;
  public getBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getBudgetBuckets.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsBudgetBucketsBudgetBucketModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsBudgetBucketsBudgetBucketModel>>;
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsBudgetBucketsBudgetBucketModel>>>;
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsBudgetBucketsBudgetBucketModel>>>;
  public getBudgetBucketsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetBudgetBucketsPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getBudgetBucketsPlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-buckets`;
    return this.httpClient.request<Array<SeasonsBudgetBucketsBudgetBucketModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search for specific record entity by id
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetByIdRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRecordsRecordModel>;
  public getByIdRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetByIdRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRecordsRecordModel>>;
  public getByIdRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetByIdRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRecordsRecordModel>>;
  public getByIdRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetByIdRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const recordId = requestParameters?.recordId;
    if (recordId === null || recordId === undefined) {
      throw new Error('Required parameter recordId was null or undefined when calling getByIdRecords.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/${this.configuration.encodeParam({ name: 'recordId', value: recordId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsRecordsRecordModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public getEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public getEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public getEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error('Required parameter snapshotId was null or undefined when calling getEmployeeSnapshots.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public getInformationFieldValuesOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetInformationFieldValuesOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling getInformationFieldValuesOrganisationInformationSnapshots.'
      );
    }
    const targetProperty = requestParameters?.targetProperty;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersMemberModel>;
  public getMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersMemberModel>>;
  public getMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersMemberModel>>;
  public getMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMembers.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsMembersMemberModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getMySeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetMySeasonRecordsSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMySeasonRecordsSeasons.');
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'memberId');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/myrecords`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getOfSeasonPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetOfSeasonPublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getOfSeasonPublicationSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public getOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getOrganisationInformationSnapshots.');
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling getOrganisationInformationSnapshots.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>;
  public getOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public getOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public getOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getOrganisationSnapshots.');
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getOrganisationSnapshots.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanPopulationPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsMembersMemberModel>;
  public getPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanPopulationPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsMembersMemberModel>>;
  public getPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanPopulationPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsMembersMemberModel>>;
  public getPlanPopulationPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanPopulationPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPlanPopulationPlans.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/members`;
    return this.httpClient.request<SharedPageModelOfSeasonsMembersMemberModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanRecordsPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanRecordsPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanRecordsPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getPlanRecordsPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanRecordsPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPlanRecordsPlans.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlanSettingsPlanSettingsModel>;
  public getPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlanSettingsPlanSettingsModel>>;
  public getPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlanSettingsPlanSettingsModel>>;
  public getPlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling getPlanSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings`;
    return this.httpClient.request<SeasonsPlanSettingsPlanSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlansPlanModel>;
  public getPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlansPlanModel>>;
  public getPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlansPlanModel>>;
  public getPlans(
    requestParameters?: SeasonsIncentiveAdminServiceGetPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPlans.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPlansPlanModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public getPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public getPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetPublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getPublicationSettings.');
    }
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getPublicationSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/publication-settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Search for record models based on given query parameters
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getRecords(
    requestParameters?: SeasonsIncentiveAdminServiceGetRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getRecords.');
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;
    const firstName = requestParameters?.firstName;
    const lastName = requestParameters?.lastName;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgCode = requestParameters?.orgCode;
    const state = requestParameters?.state;
    const planName = requestParameters?.planName;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const assignmentId = requestParameters?.assignmentId;
    const isDesignReady = requestParameters?.isDesignReady;
    const letterState = requestParameters?.letterState;
    const payoutState = requestParameters?.payoutState;
    const template = requestParameters?.template;
    const workflow = requestParameters?.workflow;
    const seasonId2 = requestParameters?.seasonId2;
    const workflowInstanceState = requestParameters?.workflowInstanceState;
    const lineManagerName = requestParameters?.lineManagerName;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const lineManagerPositionClass = requestParameters?.lineManagerPositionClass;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'MemberId');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (firstName) {
      firstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FirstName');
      });
    }
    if (lastName) {
      lastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LastName');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (state) {
      state.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'State');
      });
    }
    if (planName) {
      planName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlanName');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (assignmentId !== undefined && assignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>assignmentId, 'AssignmentId');
    }
    if (isDesignReady !== undefined && isDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isDesignReady, 'IsDesignReady');
    }
    if (letterState) {
      letterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LetterState');
      });
    }
    if (payoutState) {
      payoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PayoutState');
      });
    }
    if (template !== undefined && template !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>template, 'Template');
    }
    if (workflow !== undefined && workflow !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workflow, 'Workflow');
    }
    if (seasonId2 !== undefined && seasonId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId2, 'SeasonId');
    }
    if (workflowInstanceState) {
      workflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkflowInstanceState');
      });
    }
    if (lineManagerName !== undefined && lineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lineManagerName, 'LineManagerName');
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (lineManagerPositionClass !== undefined && lineManagerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>lineManagerPositionClass,
        'LineManagerPositionClass'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritCommunicationSettingsMeritCommunicationSettingsModel>;
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public getSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonCommunicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getSeasonCommunicationSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`;
    return this.httpClient.request<MeritCommunicationSettingsMeritCommunicationSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersEmployeeSeasonOverviewModel>;
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersEmployeeSeasonOverviewModel>>;
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersEmployeeSeasonOverviewModel>>;
  public getSeasonOverviewForEmployeeMembers(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonOverviewForEmployeeMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const gid = requestParameters?.gid;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'gid');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members/overview`;
    return this.httpClient.request<SeasonsMembersEmployeeSeasonOverviewModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsRecordsRecordModel>;
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsRecordsRecordModel>>;
  public getSeasonRecordsSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonRecordsSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSeasonRecordsSeasons.');
    }
    const queryId = requestParameters?.queryId;
    const queryGid = requestParameters?.queryGid;
    const queryFirstName = requestParameters?.queryFirstName;
    const queryLastName = requestParameters?.queryLastName;
    const queryCountry = requestParameters?.queryCountry;
    const queryAre = requestParameters?.queryAre;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgClusterNodeName = requestParameters?.queryOrgClusterNodeName;
    const queryState = requestParameters?.queryState;
    const queryPlanName = requestParameters?.queryPlanName;
    const queryStartDate = requestParameters?.queryStartDate;
    const queryEndDate = requestParameters?.queryEndDate;
    const queryAssignmentId = requestParameters?.queryAssignmentId;
    const queryLetterType = requestParameters?.queryLetterType;
    const queryProcessStates = requestParameters?.queryProcessStates;
    const queryRecordCommunicationStates = requestParameters?.queryRecordCommunicationStates;
    const queryWorkflow = requestParameters?.queryWorkflow;
    const queryTemplate = requestParameters?.queryTemplate;
    const queryIsDesignReady = requestParameters?.queryIsDesignReady;
    const queryPayoutDate = requestParameters?.queryPayoutDate;
    const queryPayoutState = requestParameters?.queryPayoutState;
    const queryLineManagerName = requestParameters?.queryLineManagerName;
    const queryLineManagerGid = requestParameters?.queryLineManagerGid;
    const querySeasonId = requestParameters?.querySeasonId;
    const queryWorkflowInstanceState = requestParameters?.queryWorkflowInstanceState;
    const queryMultiplier = requestParameters?.queryMultiplier;
    const queryOverallTargetAchievement = requestParameters?.queryOverallTargetAchievement;
    const queryPayoutAmount = requestParameters?.queryPayoutAmount;
    const queryPayoutCurrency = requestParameters?.queryPayoutCurrency;
    const queryIppAchievementValue = requestParameters?.queryIppAchievementValue;
    const queryIncentivePaymentType = requestParameters?.queryIncentivePaymentType;
    const queryContractStatus = requestParameters?.queryContractStatus;
    const queryMeasurementDate = requestParameters?.queryMeasurementDate;
    const queryMeritTitle = requestParameters?.queryMeritTitle;
    const queryEquityTitle = requestParameters?.queryEquityTitle;
    const queryEquitySubTitle = requestParameters?.queryEquitySubTitle;
    const queryManuallyChanged = requestParameters?.queryManuallyChanged;
    const queryNewHire = requestParameters?.queryNewHire;
    const queryPromotion = requestParameters?.queryPromotion;
    const queryTermination = requestParameters?.queryTermination;
    const queryPopulationChange = requestParameters?.queryPopulationChange;
    const queryLineManagerFirstName = requestParameters?.queryLineManagerFirstName;
    const queryLineManagerLastName = requestParameters?.queryLineManagerLastName;
    const queryCompanyManagerFirstName = requestParameters?.queryCompanyManagerFirstName;
    const queryCompanyManagerGid = requestParameters?.queryCompanyManagerGid;
    const queryCompanyManagerLastName = requestParameters?.queryCompanyManagerLastName;
    const queryTemplateName = requestParameters?.queryTemplateName;
    const queryWorkflowType = requestParameters?.queryWorkflowType;
    const queryAutoApprove = requestParameters?.queryAutoApprove;
    const queryApprovalRequired = requestParameters?.queryApprovalRequired;
    const queryLetterState = requestParameters?.queryLetterState;
    const queryProcessState = requestParameters?.queryProcessState;
    const queryExportState = requestParameters?.queryExportState;
    const queryPayrollState = requestParameters?.queryPayrollState;
    const queryMeritRelevancy = requestParameters?.queryMeritRelevancy;
    const queryApprovedByCompanyManager = requestParameters?.queryApprovedByCompanyManager;
    const queryAllocationWorkflowType = requestParameters?.queryAllocationWorkflowType;
    const queryReadyToPayroll = requestParameters?.queryReadyToPayroll;
    const queryEquityRelevancy = requestParameters?.queryEquityRelevancy;
    const queryHasOtpIncrease = requestParameters?.queryHasOtpIncrease;
    const queryIsOtpOnly = requestParameters?.queryIsOtpOnly;
    const queryPlanTitle = requestParameters?.queryPlanTitle;
    const queryLocalCurrency = requestParameters?.queryLocalCurrency;
    const queryProposalAmount = requestParameters?.queryProposalAmount;
    const queryProposalAmountInEuro = requestParameters?.queryProposalAmountInEuro;
    const queryProposalDate = requestParameters?.queryProposalDate;
    const queryProposalState = requestParameters?.queryProposalState;
    const querySpecialPaymentReason = requestParameters?.querySpecialPaymentReason;
    const querySpecialPaymentCompensationType = requestParameters?.querySpecialPaymentCompensationType;
    const queryTemplateLetterName = requestParameters?.queryTemplateLetterName;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryId !== undefined && queryId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryId, 'Query.Id');
    }
    if (queryGid) {
      queryGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gid');
      });
    }
    if (queryFirstName) {
      queryFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.FirstName');
      });
    }
    if (queryLastName) {
      queryLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LastName');
      });
    }
    if (queryCountry) {
      queryCountry.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Country');
      });
    }
    if (queryAre) {
      queryAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Are');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgClusterNodeName) {
      queryOrgClusterNodeName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgClusterNodeName'
        );
      });
    }
    if (queryState) {
      queryState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.State');
      });
    }
    if (queryPlanName) {
      queryPlanName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlanName');
      });
    }
    if (queryStartDate !== undefined && queryStartDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryStartDate, 'Query.StartDate');
    }
    if (queryEndDate !== undefined && queryEndDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryEndDate, 'Query.EndDate');
    }
    if (queryAssignmentId !== undefined && queryAssignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAssignmentId,
        'Query.AssignmentId'
      );
    }
    if (queryLetterType !== undefined && queryLetterType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLetterType, 'Query.LetterType');
    }
    if (queryProcessStates) {
      queryProcessStates.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProcessStates');
      });
    }
    if (queryRecordCommunicationStates) {
      queryRecordCommunicationStates.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.RecordCommunicationStates'
        );
      });
    }
    if (queryWorkflow) {
      queryWorkflow.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Workflow');
      });
    }
    if (queryTemplate) {
      queryTemplate.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Template');
      });
    }
    if (queryIsDesignReady !== undefined && queryIsDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsDesignReady,
        'Query.IsDesignReady'
      );
    }
    if (queryPayoutDate !== undefined && queryPayoutDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPayoutDate, 'Query.PayoutDate');
    }
    if (queryPayoutState) {
      queryPayoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayoutState');
      });
    }
    if (queryLineManagerName !== undefined && queryLineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryLineManagerName,
        'Query.LineManagerName'
      );
    }
    if (queryLineManagerGid) {
      queryLineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LineManagerGid');
      });
    }
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryWorkflowInstanceState) {
      queryWorkflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.WorkflowInstanceState'
        );
      });
    }
    if (queryMultiplier !== undefined && queryMultiplier !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryMultiplier, 'Query.Multiplier');
    }
    if (queryOverallTargetAchievement !== undefined && queryOverallTargetAchievement !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOverallTargetAchievement,
        'Query.OverallTargetAchievement'
      );
    }
    if (queryPayoutAmount !== undefined && queryPayoutAmount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPayoutAmount,
        'Query.PayoutAmount'
      );
    }
    if (queryPayoutCurrency) {
      queryPayoutCurrency.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayoutCurrency');
      });
    }
    if (queryIppAchievementValue !== undefined && queryIppAchievementValue !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIppAchievementValue,
        'Query.IppAchievementValue'
      );
    }
    if (queryIncentivePaymentType) {
      queryIncentivePaymentType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncentivePaymentType'
        );
      });
    }
    if (queryContractStatus) {
      queryContractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ContractStatus');
      });
    }
    if (queryMeasurementDate !== undefined && queryMeasurementDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryMeasurementDate,
        'Query.MeasurementDate'
      );
    }
    if (queryMeritTitle) {
      queryMeritTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MeritTitle');
      });
    }
    if (queryEquityTitle) {
      queryEquityTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquityTitle');
      });
    }
    if (queryEquitySubTitle) {
      queryEquitySubTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquitySubTitle');
      });
    }
    if (queryManuallyChanged) {
      queryManuallyChanged.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ManuallyChanged');
      });
    }
    if (queryNewHire) {
      queryNewHire.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHire');
      });
    }
    if (queryPromotion) {
      queryPromotion.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Promotion');
      });
    }
    if (queryTermination) {
      queryTermination.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Termination');
      });
    }
    if (queryPopulationChange) {
      queryPopulationChange.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PopulationChange');
      });
    }
    if (queryLineManagerFirstName) {
      queryLineManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.LineManagerFirstName'
        );
      });
    }
    if (queryLineManagerLastName) {
      queryLineManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.LineManagerLastName'
        );
      });
    }
    if (queryCompanyManagerFirstName) {
      queryCompanyManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerFirstName'
        );
      });
    }
    if (queryCompanyManagerGid) {
      queryCompanyManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerGid'
        );
      });
    }
    if (queryCompanyManagerLastName) {
      queryCompanyManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CompanyManagerLastName'
        );
      });
    }
    if (queryTemplateName) {
      queryTemplateName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.TemplateName');
      });
    }
    if (queryWorkflowType) {
      queryWorkflowType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WorkflowType');
      });
    }
    if (queryAutoApprove !== undefined && queryAutoApprove !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAutoApprove,
        'Query.AutoApprove'
      );
    }
    if (queryApprovalRequired !== undefined && queryApprovalRequired !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryApprovalRequired,
        'Query.ApprovalRequired'
      );
    }
    if (queryLetterState) {
      queryLetterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LetterState');
      });
    }
    if (queryProcessState) {
      queryProcessState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProcessState');
      });
    }
    if (queryExportState) {
      queryExportState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ExportState');
      });
    }
    if (queryPayrollState) {
      queryPayrollState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PayrollState');
      });
    }
    if (queryMeritRelevancy) {
      queryMeritRelevancy.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MeritRelevancy');
      });
    }
    if (queryApprovedByCompanyManager !== undefined && queryApprovedByCompanyManager !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryApprovedByCompanyManager,
        'Query.ApprovedByCompanyManager'
      );
    }
    if (queryAllocationWorkflowType) {
      queryAllocationWorkflowType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.AllocationWorkflowType'
        );
      });
    }
    if (queryReadyToPayroll !== undefined && queryReadyToPayroll !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryReadyToPayroll,
        'Query.ReadyToPayroll'
      );
    }
    if (queryEquityRelevancy) {
      queryEquityRelevancy.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.EquityRelevancy');
      });
    }
    if (queryHasOtpIncrease !== undefined && queryHasOtpIncrease !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHasOtpIncrease,
        'Query.HasOtpIncrease'
      );
    }
    if (queryIsOtpOnly !== undefined && queryIsOtpOnly !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsOtpOnly, 'Query.IsOtpOnly');
    }
    if (queryPlanTitle) {
      queryPlanTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlanTitle');
      });
    }
    if (queryLocalCurrency) {
      queryLocalCurrency.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.LocalCurrency');
      });
    }
    if (queryProposalAmount !== undefined && queryProposalAmount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalAmount,
        'Query.ProposalAmount'
      );
    }
    if (queryProposalAmountInEuro !== undefined && queryProposalAmountInEuro !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalAmountInEuro,
        'Query.ProposalAmountInEuro'
      );
    }
    if (queryProposalDate !== undefined && queryProposalDate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryProposalDate,
        'Query.ProposalDate'
      );
    }
    if (queryProposalState) {
      queryProposalState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ProposalState');
      });
    }
    if (querySpecialPaymentReason) {
      querySpecialPaymentReason.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.SpecialPaymentReason'
        );
      });
    }
    if (querySpecialPaymentCompensationType) {
      querySpecialPaymentCompensationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.SpecialPaymentCompensationType'
        );
      });
    }
    if (queryTemplateLetterName) {
      queryTemplateLetterName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.TemplateLetterName'
        );
      });
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/records`;
    return this.httpClient.request<SharedPageModelOfSeasonsRecordsRecordModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSettingsSeasonSettingsModel>;
  public getSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSettingsSeasonSettingsModel>>;
  public getSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSettingsSeasonSettingsModel>>;
  public getSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getSeasonSettings.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/settings/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSettingsSeasonSettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSeasonsSeasonModel>;
  public getSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSeasonsSeasonModel>>;
  public getSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSeasonsSeasonModel>>;
  public getSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSeasonsSeasonModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceGetSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>;
  public getSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceGetSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public getSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceGetSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public getSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceGetSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error('Required parameter simulationId was null or undefined when calling getSimulation.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSnapshotSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSnapshotsSnapshotModel>;
  public getSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSnapshotSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSnapshotsSnapshotModel>>;
  public getSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSnapshotSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSnapshotsSnapshotModel>>;
  public getSnapshotSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceGetSnapshotSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getSnapshotSeasons.');
    }
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error('Required parameter employeeId was null or undefined when calling getSnapshotSeasons.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSnapshotsSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>;
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>>;
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>>;
  public getTreeOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceGetTreeOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling getTreeOrganisationSnapshots.');
    }
    const parentOrgCode = requestParameters?.parentOrgCode;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (parentOrgCode !== undefined && parentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>parentOrgCode, 'parentOrgCode');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/tree`;
    return this.httpClient.request<Array<SeasonsOrganisationSnapshotsOrganisationSnapshotTreeItemModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public partialUpdateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServicePartialUpdateEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const snapshotId = requestParameters?.snapshotId;
    if (snapshotId === null || snapshotId === undefined) {
      throw new Error(
        'Required parameter snapshotId was null or undefined when calling partialUpdateEmployeeSnapshots.'
      );
    }
    const seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel =
      requestParameters?.seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots/${this.configuration.encodeParam({ name: 'snapshotId', value: snapshotId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsEmployeeSnapshotsUpdateEmployeeSnapshotPartialModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public prePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePrePublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public prePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePrePublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public prePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePrePublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public prePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePrePublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling prePublishSimulationPublications.'
      );
    }
    const positionName = requestParameters?.positionName;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const orgLevel = requestParameters?.orgLevel;
    const orgSize = requestParameters?.orgSize;
    const mercerJobCode = requestParameters?.mercerJobCode;
    const positionClass = requestParameters?.positionClass;
    const newPositionClass = requestParameters?.newPositionClass;
    const originalProposedPositionClass = requestParameters?.originalProposedPositionClass;
    const positionType = requestParameters?.positionType;
    const countryIsoCode = requestParameters?.countryIsoCode;
    const incumbentGid = requestParameters?.incumbentGid;
    const incumbentFirstName = requestParameters?.incumbentFirstName;
    const incumbentLastName = requestParameters?.incumbentLastName;
    const incumbentCountryPlaceOfAction = requestParameters?.incumbentCountryPlaceOfAction;
    const validationManagerId = requestParameters?.validationManagerId;
    const validationManagerGid = requestParameters?.validationManagerGid;
    const validationManagerFirstName = requestParameters?.validationManagerFirstName;
    const validationManagerLastName = requestParameters?.validationManagerLastName;
    const validationState = requestParameters?.validationState;
    const placementState = requestParameters?.placementState;
    const newHireState = requestParameters?.newHireState;
    const isLocked = requestParameters?.isLocked;
    const mercerJobFamily = requestParameters?.mercerJobFamily;
    const mercerJobSpecialization = requestParameters?.mercerJobSpecialization;
    const mercerJobSubFamily = requestParameters?.mercerJobSubFamily;
    const incumbentAre = requestParameters?.incumbentAre;
    const tag = requestParameters?.tag;
    const wasPromoted = requestParameters?.wasPromoted;
    const isTransferred = requestParameters?.isTransferred;
    const seasonsSimulationPublicationsPublishSimulationModel =
      requestParameters?.seasonsSimulationPublicationsPublishSimulationModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (positionName) {
      positionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionName');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (orgSize) {
      orgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgSize');
      });
    }
    if (mercerJobCode) {
      mercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobCode');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (newPositionClass) {
      newPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'NewPositionClass');
      });
    }
    if (originalProposedPositionClass) {
      originalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'OriginalProposedPositionClass'
        );
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (countryIsoCode) {
      countryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryIsoCode');
      });
    }
    if (incumbentGid) {
      incumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentGid');
      });
    }
    if (incumbentFirstName) {
      incumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentFirstName');
      });
    }
    if (incumbentLastName) {
      incumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentLastName');
      });
    }
    if (incumbentCountryPlaceOfAction) {
      incumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (validationManagerId) {
      validationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationManagerId');
      });
    }
    if (validationManagerGid) {
      validationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationManagerGid');
      });
    }
    if (validationManagerFirstName) {
      validationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'ValidationManagerFirstName'
        );
      });
    }
    if (validationManagerLastName) {
      validationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'ValidationManagerLastName'
        );
      });
    }
    if (validationState) {
      validationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ValidationState');
      });
    }
    if (placementState) {
      placementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlacementState');
      });
    }
    if (newHireState) {
      newHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'NewHireState');
      });
    }
    if (isLocked) {
      isLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsLocked');
      });
    }
    if (mercerJobFamily) {
      mercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobFamily');
      });
    }
    if (mercerJobSpecialization) {
      mercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'MercerJobSpecialization'
        );
      });
    }
    if (mercerJobSubFamily) {
      mercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerJobSubFamily');
      });
    }
    if (incumbentAre) {
      incumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IncumbentAre');
      });
    }
    if (tag) {
      tag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Tag');
      });
    }
    if (wasPromoted) {
      wasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WasPromoted');
      });
    }
    if (isTransferred) {
      isTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/pre-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationPublicationsPublishSimulationModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public publishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public publishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public publishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public publishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServicePublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling publishSimulationPublications.'
      );
    }
    const queryPositionName = requestParameters?.queryPositionName;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgCodeStartsWith = requestParameters?.queryOrgCodeStartsWith;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryMercerJobCode = requestParameters?.queryMercerJobCode;
    const queryPositionClass = requestParameters?.queryPositionClass;
    const queryNewPositionClass = requestParameters?.queryNewPositionClass;
    const queryOriginalProposedPositionClass = requestParameters?.queryOriginalProposedPositionClass;
    const queryPositionType = requestParameters?.queryPositionType;
    const queryCountryIsoCode = requestParameters?.queryCountryIsoCode;
    const queryIncumbentGid = requestParameters?.queryIncumbentGid;
    const queryIncumbentFirstName = requestParameters?.queryIncumbentFirstName;
    const queryIncumbentLastName = requestParameters?.queryIncumbentLastName;
    const queryIncumbentCountryPlaceOfAction = requestParameters?.queryIncumbentCountryPlaceOfAction;
    const queryValidationManagerId = requestParameters?.queryValidationManagerId;
    const queryValidationManagerGid = requestParameters?.queryValidationManagerGid;
    const queryValidationManagerFirstName = requestParameters?.queryValidationManagerFirstName;
    const queryValidationManagerLastName = requestParameters?.queryValidationManagerLastName;
    const queryValidationState = requestParameters?.queryValidationState;
    const queryPlacementState = requestParameters?.queryPlacementState;
    const queryNewHireState = requestParameters?.queryNewHireState;
    const queryIsLocked = requestParameters?.queryIsLocked;
    const queryMercerJobFamily = requestParameters?.queryMercerJobFamily;
    const queryMercerJobSpecialization = requestParameters?.queryMercerJobSpecialization;
    const queryMercerJobSubFamily = requestParameters?.queryMercerJobSubFamily;
    const queryIncumbentAre = requestParameters?.queryIncumbentAre;
    const queryTag = requestParameters?.queryTag;
    const queryWasPromoted = requestParameters?.queryWasPromoted;
    const queryIsTransferred = requestParameters?.queryIsTransferred;
    const seasonsSimulationPublicationsPublishSimulationModel =
      requestParameters?.seasonsSimulationPublicationsPublishSimulationModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryPositionName) {
      queryPositionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionName');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgCodeStartsWith) {
      queryOrgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgCodeStartsWith'
        );
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryOrgSize) {
      queryOrgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgSize');
      });
    }
    if (queryMercerJobCode) {
      queryMercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobCode');
      });
    }
    if (queryPositionClass) {
      queryPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionClass');
      });
    }
    if (queryNewPositionClass) {
      queryNewPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewPositionClass');
      });
    }
    if (queryOriginalProposedPositionClass) {
      queryOriginalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OriginalProposedPositionClass'
        );
      });
    }
    if (queryPositionType) {
      queryPositionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionType');
      });
    }
    if (queryCountryIsoCode) {
      queryCountryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.CountryIsoCode');
      });
    }
    if (queryIncumbentGid) {
      queryIncumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentGid');
      });
    }
    if (queryIncumbentFirstName) {
      queryIncumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentFirstName'
        );
      });
    }
    if (queryIncumbentLastName) {
      queryIncumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentLastName'
        );
      });
    }
    if (queryIncumbentCountryPlaceOfAction) {
      queryIncumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (queryValidationManagerId) {
      queryValidationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerId'
        );
      });
    }
    if (queryValidationManagerGid) {
      queryValidationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerGid'
        );
      });
    }
    if (queryValidationManagerFirstName) {
      queryValidationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerFirstName'
        );
      });
    }
    if (queryValidationManagerLastName) {
      queryValidationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerLastName'
        );
      });
    }
    if (queryValidationState) {
      queryValidationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ValidationState');
      });
    }
    if (queryPlacementState) {
      queryPlacementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlacementState');
      });
    }
    if (queryNewHireState) {
      queryNewHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHireState');
      });
    }
    if (queryIsLocked) {
      queryIsLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsLocked');
      });
    }
    if (queryMercerJobFamily) {
      queryMercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobFamily');
      });
    }
    if (queryMercerJobSpecialization) {
      queryMercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSpecialization'
        );
      });
    }
    if (queryMercerJobSubFamily) {
      queryMercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSubFamily'
        );
      });
    }
    if (queryIncumbentAre) {
      queryIncumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentAre');
      });
    }
    if (queryTag) {
      queryTag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Tag');
      });
    }
    if (queryWasPromoted) {
      queryWasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WasPromoted');
      });
    }
    if (queryIsTransferred) {
      queryIsTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationPublicationsPublishSimulationModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceQueryCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsCandidatePoolsCandidatePoolModel>>;
  public queryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceQueryCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsCandidatePoolsCandidatePoolModel>>>;
  public queryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceQueryCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsCandidatePoolsCandidatePoolModel>>>;
  public queryCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceQueryCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'seasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools`;
    return this.httpClient.request<Array<SeasonsCandidatePoolsCandidatePoolModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeCandidatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>;
  public queryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeCandidatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>>;
  public queryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeCandidatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>>;
  public queryEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeCandidatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const queryGid = requestParameters?.queryGid;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryLastname = requestParameters?.queryLastname;
    const queryPAOrgCode = requestParameters?.queryPAOrgCode;
    const queryCandidatePoolTitle = requestParameters?.queryCandidatePoolTitle;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryGender = requestParameters?.queryGender;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryMercerPositionClass = requestParameters?.queryMercerPositionClass;
    const queryIsPlaced = requestParameters?.queryIsPlaced;
    const queryIsShortlisted = requestParameters?.queryIsShortlisted;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryPAOrgCode) {
      queryPAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PAOrgCode');
      });
    }
    if (queryCandidatePoolTitle) {
      queryCandidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.CandidatePoolTitle'
        );
      });
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryGender) {
      queryGender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Gender');
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryMercerPositionClass) {
      queryMercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerPositionClass'
        );
      });
    }
    if (queryIsPlaced !== undefined && queryIsPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryIsPlaced, 'Query.IsPlaced');
    }
    if (queryIsShortlisted !== undefined && queryIsShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryIsShortlisted,
        'Query.IsShortlisted'
      );
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-candidates`;
    return this.httpClient.request<SharedPageModelOfPositionEvaluationEmployeeCandidatesPositionEvaluationCandidateModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public queryEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots`;
    return this.httpClient.request<SharedPageModelOfSeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesEmployeeCandidates(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesEmployeeCandidatesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    const seasonId = requestParameters?.seasonId;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const gid = requestParameters?.gid;
    const firstname = requestParameters?.firstname;
    const lastname = requestParameters?.lastname;
    const pAOrgCode = requestParameters?.pAOrgCode;
    const candidatePoolTitle = requestParameters?.candidatePoolTitle;
    const orgCode = requestParameters?.orgCode;
    const gender = requestParameters?.gender;
    const orgLevel = requestParameters?.orgLevel;
    const mercerPositionClass = requestParameters?.mercerPositionClass;
    const isPlaced = requestParameters?.isPlaced;
    const isShortlisted = requestParameters?.isShortlisted;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (gid !== undefined && gid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>gid, 'Gid');
    }
    if (firstname !== undefined && firstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>firstname, 'Firstname');
    }
    if (lastname !== undefined && lastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lastname, 'Lastname');
    }
    if (pAOrgCode) {
      pAOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PAOrgCode');
      });
    }
    if (candidatePoolTitle) {
      candidatePoolTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CandidatePoolTitle');
      });
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (gender) {
      gender.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gender');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (mercerPositionClass) {
      mercerPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'MercerPositionClass');
      });
    }
    if (isPlaced !== undefined && isPlaced !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isPlaced, 'IsPlaced');
    }
    if (isShortlisted !== undefined && isShortlisted !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isShortlisted, 'IsShortlisted');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-candidates/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling queryFieldValuesOrganisationSnapshots.'
      );
    }
    const targetProperty = requestParameters?.targetProperty;
    const orgCode = requestParameters?.orgCode;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get possible field values for given record property
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesRecordsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesRecordsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesRecordsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryFieldValuesRecords(
    requestParameters?: SeasonsIncentiveAdminServiceQueryFieldValuesRecordsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error('Required parameter targetProperty was null or undefined when calling queryFieldValuesRecords.');
    }
    const memberId = requestParameters?.memberId;
    const gid = requestParameters?.gid;
    const firstName = requestParameters?.firstName;
    const lastName = requestParameters?.lastName;
    const country = requestParameters?.country;
    const are = requestParameters?.are;
    const orgCode = requestParameters?.orgCode;
    const state = requestParameters?.state;
    const planName = requestParameters?.planName;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const assignmentId = requestParameters?.assignmentId;
    const isDesignReady = requestParameters?.isDesignReady;
    const letterState = requestParameters?.letterState;
    const payoutState = requestParameters?.payoutState;
    const template = requestParameters?.template;
    const workflow = requestParameters?.workflow;
    const seasonId = requestParameters?.seasonId;
    const workflowInstanceState = requestParameters?.workflowInstanceState;
    const lineManagerName = requestParameters?.lineManagerName;
    const lineManagerGid = requestParameters?.lineManagerGid;
    const lineManagerPositionClass = requestParameters?.lineManagerPositionClass;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (memberId !== undefined && memberId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>memberId, 'MemberId');
    }
    if (gid) {
      gid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Gid');
      });
    }
    if (firstName) {
      firstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'FirstName');
      });
    }
    if (lastName) {
      lastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LastName');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (are) {
      are.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Are');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (state) {
      state.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'State');
      });
    }
    if (planName) {
      planName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PlanName');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (assignmentId !== undefined && assignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>assignmentId, 'AssignmentId');
    }
    if (isDesignReady !== undefined && isDesignReady !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>isDesignReady, 'IsDesignReady');
    }
    if (letterState) {
      letterState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LetterState');
      });
    }
    if (payoutState) {
      payoutState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PayoutState');
      });
    }
    if (template !== undefined && template !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>template, 'Template');
    }
    if (workflow !== undefined && workflow !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workflow, 'Workflow');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (workflowInstanceState) {
      workflowInstanceState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkflowInstanceState');
      });
    }
    if (lineManagerName !== undefined && lineManagerName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>lineManagerName, 'LineManagerName');
    }
    if (lineManagerGid) {
      lineManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LineManagerGid');
      });
    }
    if (lineManagerPositionClass !== undefined && lineManagerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>lineManagerPositionClass,
        'LineManagerPositionClass'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/records/field-values`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>
  >;
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>
  >;
  public queryInformationOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling queryInformationOrganisationInformationSnapshots.'
      );
    }
    const orgCode = requestParameters?.orgCode;
    const orgName = requestParameters?.orgName;
    const orgSize = requestParameters?.orgSize;
    const revenue = requestParameters?.revenue;
    const headCount = requestParameters?.headCount;
    const revenueOrgSize = requestParameters?.revenueOrgSize;
    const headCountOrgSize = requestParameters?.headCountOrgSize;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgName) {
      orgName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgName');
      });
    }
    if (orgSize !== undefined && orgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgSize, 'OrgSize');
    }
    if (revenue !== undefined && revenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenue, 'Revenue');
    }
    if (headCount !== undefined && headCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>headCount, 'HeadCount');
    }
    if (revenueOrgSize !== undefined && revenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>revenueOrgSize, 'RevenueOrgSize');
    }
    if (headCountOrgSize !== undefined && headCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headCountOrgSize,
        'HeadCountOrgSize'
      );
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information`;
    return this.httpClient.request<SharedPageModelOfSeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>;
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>
  >;
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public queryInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceQueryInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling queryInformationVisibilitySettings.'
      );
    }
    const queryTargetProperty = requestParameters?.queryTargetProperty;
    const queryTargetTypeString = requestParameters?.queryTargetTypeString;
    const querySimulationId = requestParameters?.querySimulationId;
    const queryPriority = requestParameters?.queryPriority;
    const queryTitle = requestParameters?.queryTitle;
    const queryAffectedCount = requestParameters?.queryAffectedCount;
    const queryType = requestParameters?.queryType;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryTargetProperty !== undefined && queryTargetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetProperty,
        'Query.TargetProperty'
      );
    }
    if (queryTargetTypeString !== undefined && queryTargetTypeString !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryTargetTypeString,
        'Query.TargetTypeString'
      );
    }
    if (querySimulationId !== undefined && querySimulationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>querySimulationId,
        'Query.SimulationId'
      );
    }
    if (queryPriority !== undefined && queryPriority !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPriority, 'Query.Priority');
    }
    if (queryTitle !== undefined && queryTitle !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryTitle, 'Query.Title');
    }
    if (queryAffectedCount !== undefined && queryAffectedCount !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAffectedCount,
        'Query.AffectedCount'
      );
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'Query.Type');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility`;
    return this.httpClient.request<SharedPageModelOfMeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryMembers(
    requestParameters?: SeasonsIncentiveAdminServiceQueryMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsMembersMemberModel>;
  public queryMembers(
    requestParameters?: SeasonsIncentiveAdminServiceQueryMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsMembersMemberModel>>;
  public queryMembers(
    requestParameters?: SeasonsIncentiveAdminServiceQueryMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsMembersMemberModel>>;
  public queryMembers(
    requestParameters?: SeasonsIncentiveAdminServiceQueryMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members`;
    return this.httpClient.request<SharedPageModelOfSeasonsMembersMemberModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>;
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling queryOrganisationSnapshots.');
    }
    const querySeasonId = requestParameters?.querySeasonId;
    const queryOrganisationId = requestParameters?.queryOrganisationId;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryParentOrgCode = requestParameters?.queryParentOrgCode;
    const queryHeadId = requestParameters?.queryHeadId;
    const queryHeadGid = requestParameters?.queryHeadGid;
    const queryHeadName = requestParameters?.queryHeadName;
    const queryPositionName = requestParameters?.queryPositionName;
    const queryAdditionalLineOne = requestParameters?.queryAdditionalLineOne;
    const queryAdditionalLineTwo = requestParameters?.queryAdditionalLineTwo;
    const queryAdditionalLineThree = requestParameters?.queryAdditionalLineThree;
    const queryAdditionalLineFour = requestParameters?.queryAdditionalLineFour;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryOrgType = requestParameters?.queryOrgType;
    const queryOrgLevelA = requestParameters?.queryOrgLevelA;
    const queryOrgLevelB = requestParameters?.queryOrgLevelB;
    const queryOrgLevelC = requestParameters?.queryOrgLevelC;
    const queryOrgLevelD = requestParameters?.queryOrgLevelD;
    const queryNumberOfEmployees = requestParameters?.queryNumberOfEmployees;
    const queryHeadFirstname = requestParameters?.queryHeadFirstname;
    const queryHeadLastname = requestParameters?.queryHeadLastname;
    const queryHeadPAOrgCode = requestParameters?.queryHeadPAOrgCode;
    const queryHeadPlaceOfAction = requestParameters?.queryHeadPlaceOfAction;
    const queryHeadMercerJobCode = requestParameters?.queryHeadMercerJobCode;
    const queryHeadMercerPositionClass = requestParameters?.queryHeadMercerPositionClass;
    const queryHeadManagementGroup = requestParameters?.queryHeadManagementGroup;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryRevenue = requestParameters?.queryRevenue;
    const queryHeadCount = requestParameters?.queryHeadCount;
    const queryRevenueOrgSize = requestParameters?.queryRevenueOrgSize;
    const queryHeadCountOrgSize = requestParameters?.queryHeadCountOrgSize;
    const queryShowOrganisationsWithoutOrgInfos = requestParameters?.queryShowOrganisationsWithoutOrgInfos;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryOrganisationId !== undefined && queryOrganisationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrganisationId,
        'Query.OrganisationId'
      );
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryOrgLevel !== undefined && queryOrgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevel, 'Query.OrgLevel');
    }
    if (queryParentOrgCode !== undefined && queryParentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryParentOrgCode,
        'Query.ParentOrgCode'
      );
    }
    if (queryHeadId !== undefined && queryHeadId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadId, 'Query.HeadId');
    }
    if (queryHeadGid !== undefined && queryHeadGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadGid, 'Query.HeadGid');
    }
    if (queryHeadName !== undefined && queryHeadName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadName, 'Query.HeadName');
    }
    if (queryPositionName !== undefined && queryPositionName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPositionName,
        'Query.PositionName'
      );
    }
    if (queryAdditionalLineOne !== undefined && queryAdditionalLineOne !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineOne,
        'Query.AdditionalLineOne'
      );
    }
    if (queryAdditionalLineTwo !== undefined && queryAdditionalLineTwo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineTwo,
        'Query.AdditionalLineTwo'
      );
    }
    if (queryAdditionalLineThree !== undefined && queryAdditionalLineThree !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineThree,
        'Query.AdditionalLineThree'
      );
    }
    if (queryAdditionalLineFour !== undefined && queryAdditionalLineFour !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineFour,
        'Query.AdditionalLineFour'
      );
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryOrgType !== undefined && queryOrgType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgType, 'Query.OrgType');
    }
    if (queryOrgLevelA !== undefined && queryOrgLevelA !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelA, 'Query.OrgLevelA');
    }
    if (queryOrgLevelB !== undefined && queryOrgLevelB !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelB, 'Query.OrgLevelB');
    }
    if (queryOrgLevelC !== undefined && queryOrgLevelC !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelC, 'Query.OrgLevelC');
    }
    if (queryOrgLevelD !== undefined && queryOrgLevelD !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelD, 'Query.OrgLevelD');
    }
    if (queryNumberOfEmployees !== undefined && queryNumberOfEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryNumberOfEmployees,
        'Query.NumberOfEmployees'
      );
    }
    if (queryHeadFirstname !== undefined && queryHeadFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadFirstname,
        'Query.HeadFirstname'
      );
    }
    if (queryHeadLastname !== undefined && queryHeadLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadLastname,
        'Query.HeadLastname'
      );
    }
    if (queryHeadPAOrgCode !== undefined && queryHeadPAOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPAOrgCode,
        'Query.HeadPAOrgCode'
      );
    }
    if (queryHeadPlaceOfAction !== undefined && queryHeadPlaceOfAction !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPlaceOfAction,
        'Query.HeadPlaceOfAction'
      );
    }
    if (queryHeadMercerJobCode !== undefined && queryHeadMercerJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerJobCode,
        'Query.HeadMercerJobCode'
      );
    }
    if (queryHeadMercerPositionClass !== undefined && queryHeadMercerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerPositionClass,
        'Query.HeadMercerPositionClass'
      );
    }
    if (queryHeadManagementGroup !== undefined && queryHeadManagementGroup !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadManagementGroup,
        'Query.HeadManagementGroup'
      );
    }
    if (queryOrgSize !== undefined && queryOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgSize, 'Query.OrgSize');
    }
    if (queryRevenue !== undefined && queryRevenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryRevenue, 'Query.Revenue');
    }
    if (queryHeadCount !== undefined && queryHeadCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadCount, 'Query.HeadCount');
    }
    if (queryRevenueOrgSize !== undefined && queryRevenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRevenueOrgSize,
        'Query.RevenueOrgSize'
      );
    }
    if (queryHeadCountOrgSize !== undefined && queryHeadCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadCountOrgSize,
        'Query.HeadCountOrgSize'
      );
    }
    if (queryShowOrganisationsWithoutOrgInfos !== undefined && queryShowOrganisationsWithoutOrgInfos !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryShowOrganisationsWithoutOrgInfos,
        'Query.ShowOrganisationsWithoutOrgInfos'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations`;
    return this.httpClient.request<SharedPageModelOfSeasonsOrganisationSnapshotsOrganisationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsSnapshotsSnapshotModel>;
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsSnapshotsSnapshotModel>>;
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsSnapshotsSnapshotModel>>;
  public queryOrganisationSnapshotsAndEmployeeSnapshotsSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryOrganisationSnapshotsAndEmployeeSnapshotsSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const meritSeasonId = requestParameters?.meritSeasonId;
    const search = requestParameters?.search;
    const directs = requestParameters?.directs;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const impersonatedEmployee = requestParameters?.impersonatedEmployee;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (meritSeasonId !== undefined && meritSeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>meritSeasonId, 'MeritSeasonId');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (directs !== undefined && directs !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>directs, 'Directs');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (impersonatedEmployee !== undefined && impersonatedEmployee !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>impersonatedEmployee,
        'impersonatedEmployee'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/snapshots/employees`;
    return this.httpClient.request<SharedPageModelOfSeasonsSnapshotsSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>;
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>>;
  public queryParentsOrganisationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceQueryParentsOrganisationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling queryParentsOrganisationSnapshots.'
      );
    }
    const seasonId2 = requestParameters?.seasonId2;
    if (seasonId2 === null || seasonId2 === undefined) {
      throw new Error(
        'Required parameter seasonId2 was null or undefined when calling queryParentsOrganisationSnapshots.'
      );
    }
    const querySeasonId = requestParameters?.querySeasonId;
    const queryOrganisationId = requestParameters?.queryOrganisationId;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryParentOrgCode = requestParameters?.queryParentOrgCode;
    const queryHeadId = requestParameters?.queryHeadId;
    const queryHeadGid = requestParameters?.queryHeadGid;
    const queryHeadName = requestParameters?.queryHeadName;
    const queryPositionName = requestParameters?.queryPositionName;
    const queryAdditionalLineOne = requestParameters?.queryAdditionalLineOne;
    const queryAdditionalLineTwo = requestParameters?.queryAdditionalLineTwo;
    const queryAdditionalLineThree = requestParameters?.queryAdditionalLineThree;
    const queryAdditionalLineFour = requestParameters?.queryAdditionalLineFour;
    const queryOrgName = requestParameters?.queryOrgName;
    const queryOrgType = requestParameters?.queryOrgType;
    const queryOrgLevelA = requestParameters?.queryOrgLevelA;
    const queryOrgLevelB = requestParameters?.queryOrgLevelB;
    const queryOrgLevelC = requestParameters?.queryOrgLevelC;
    const queryOrgLevelD = requestParameters?.queryOrgLevelD;
    const queryNumberOfEmployees = requestParameters?.queryNumberOfEmployees;
    const queryHeadFirstname = requestParameters?.queryHeadFirstname;
    const queryHeadLastname = requestParameters?.queryHeadLastname;
    const queryHeadPAOrgCode = requestParameters?.queryHeadPAOrgCode;
    const queryHeadPlaceOfAction = requestParameters?.queryHeadPlaceOfAction;
    const queryHeadMercerJobCode = requestParameters?.queryHeadMercerJobCode;
    const queryHeadMercerPositionClass = requestParameters?.queryHeadMercerPositionClass;
    const queryHeadManagementGroup = requestParameters?.queryHeadManagementGroup;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryRevenue = requestParameters?.queryRevenue;
    const queryHeadCount = requestParameters?.queryHeadCount;
    const queryRevenueOrgSize = requestParameters?.queryRevenueOrgSize;
    const queryHeadCountOrgSize = requestParameters?.queryHeadCountOrgSize;
    const queryShowOrganisationsWithoutOrgInfos = requestParameters?.queryShowOrganisationsWithoutOrgInfos;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId2 !== undefined && seasonId2 !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId2, 'SeasonId');
    }
    if (querySeasonId !== undefined && querySeasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>querySeasonId, 'Query.SeasonId');
    }
    if (queryOrganisationId !== undefined && queryOrganisationId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrganisationId,
        'Query.OrganisationId'
      );
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryOrgLevel !== undefined && queryOrgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevel, 'Query.OrgLevel');
    }
    if (queryParentOrgCode !== undefined && queryParentOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryParentOrgCode,
        'Query.ParentOrgCode'
      );
    }
    if (queryHeadId !== undefined && queryHeadId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadId, 'Query.HeadId');
    }
    if (queryHeadGid !== undefined && queryHeadGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadGid, 'Query.HeadGid');
    }
    if (queryHeadName !== undefined && queryHeadName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadName, 'Query.HeadName');
    }
    if (queryPositionName !== undefined && queryPositionName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPositionName,
        'Query.PositionName'
      );
    }
    if (queryAdditionalLineOne !== undefined && queryAdditionalLineOne !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineOne,
        'Query.AdditionalLineOne'
      );
    }
    if (queryAdditionalLineTwo !== undefined && queryAdditionalLineTwo !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineTwo,
        'Query.AdditionalLineTwo'
      );
    }
    if (queryAdditionalLineThree !== undefined && queryAdditionalLineThree !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineThree,
        'Query.AdditionalLineThree'
      );
    }
    if (queryAdditionalLineFour !== undefined && queryAdditionalLineFour !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAdditionalLineFour,
        'Query.AdditionalLineFour'
      );
    }
    if (queryOrgName !== undefined && queryOrgName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgName, 'Query.OrgName');
    }
    if (queryOrgType !== undefined && queryOrgType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgType, 'Query.OrgType');
    }
    if (queryOrgLevelA !== undefined && queryOrgLevelA !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelA, 'Query.OrgLevelA');
    }
    if (queryOrgLevelB !== undefined && queryOrgLevelB !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelB, 'Query.OrgLevelB');
    }
    if (queryOrgLevelC !== undefined && queryOrgLevelC !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelC, 'Query.OrgLevelC');
    }
    if (queryOrgLevelD !== undefined && queryOrgLevelD !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgLevelD, 'Query.OrgLevelD');
    }
    if (queryNumberOfEmployees !== undefined && queryNumberOfEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryNumberOfEmployees,
        'Query.NumberOfEmployees'
      );
    }
    if (queryHeadFirstname !== undefined && queryHeadFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadFirstname,
        'Query.HeadFirstname'
      );
    }
    if (queryHeadLastname !== undefined && queryHeadLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadLastname,
        'Query.HeadLastname'
      );
    }
    if (queryHeadPAOrgCode !== undefined && queryHeadPAOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPAOrgCode,
        'Query.HeadPAOrgCode'
      );
    }
    if (queryHeadPlaceOfAction !== undefined && queryHeadPlaceOfAction !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadPlaceOfAction,
        'Query.HeadPlaceOfAction'
      );
    }
    if (queryHeadMercerJobCode !== undefined && queryHeadMercerJobCode !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerJobCode,
        'Query.HeadMercerJobCode'
      );
    }
    if (queryHeadMercerPositionClass !== undefined && queryHeadMercerPositionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadMercerPositionClass,
        'Query.HeadMercerPositionClass'
      );
    }
    if (queryHeadManagementGroup !== undefined && queryHeadManagementGroup !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadManagementGroup,
        'Query.HeadManagementGroup'
      );
    }
    if (queryOrgSize !== undefined && queryOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgSize, 'Query.OrgSize');
    }
    if (queryRevenue !== undefined && queryRevenue !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryRevenue, 'Query.Revenue');
    }
    if (queryHeadCount !== undefined && queryHeadCount !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryHeadCount, 'Query.HeadCount');
    }
    if (queryRevenueOrgSize !== undefined && queryRevenueOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRevenueOrgSize,
        'Query.RevenueOrgSize'
      );
    }
    if (queryHeadCountOrgSize !== undefined && queryHeadCountOrgSize !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryHeadCountOrgSize,
        'Query.HeadCountOrgSize'
      );
    }
    if (queryShowOrganisationsWithoutOrgInfos !== undefined && queryShowOrganisationsWithoutOrgInfos !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryShowOrganisationsWithoutOrgInfos,
        'Query.ShowOrganisationsWithoutOrgInfos'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/parents`;
    return this.httpClient.request<SeasonsOrganisationSnapshotsOrganisationSnapshotModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>;
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>
  >;
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>>;
  public queryPlanWithMissingIndividualValues(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlanWithMissingIndividualValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    const queryKpiId = requestParameters?.queryKpiId;
    const queryAssignmentId = requestParameters?.queryAssignmentId;
    const queryOrgClusterNodeName = requestParameters?.queryOrgClusterNodeName;
    const queryGid = requestParameters?.queryGid;
    const queryLastname = requestParameters?.queryLastname;
    const queryFirstname = requestParameters?.queryFirstname;
    const queryCountry = requestParameters?.queryCountry;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryRecordStartdate = requestParameters?.queryRecordStartdate;
    const queryPlanName = requestParameters?.queryPlanName;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'SeasonId');
    }
    if (queryKpiId !== undefined && queryKpiId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryKpiId, 'Query.KpiId');
    }
    if (queryAssignmentId !== undefined && queryAssignmentId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryAssignmentId,
        'Query.AssignmentId'
      );
    }
    if (queryOrgClusterNodeName !== undefined && queryOrgClusterNodeName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryOrgClusterNodeName,
        'Query.OrgClusterNodeName'
      );
    }
    if (queryGid !== undefined && queryGid !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryGid, 'Query.Gid');
    }
    if (queryLastname !== undefined && queryLastname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryLastname, 'Query.Lastname');
    }
    if (queryFirstname !== undefined && queryFirstname !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryFirstname, 'Query.Firstname');
    }
    if (queryCountry !== undefined && queryCountry !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryCountry, 'Query.Country');
    }
    if (queryOrgCode !== undefined && queryOrgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryOrgCode, 'Query.OrgCode');
    }
    if (queryRecordStartdate !== undefined && queryRecordStartdate !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryRecordStartdate,
        'Query.RecordStartdate'
      );
    }
    if (queryPlanName !== undefined && queryPlanName !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryPlanName, 'Query.PlanName');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/missing-individual-values`;
    return this.httpClient.request<SharedPageModelOfSeasonsPlanWithMissingIndividualValuesPlanWithMissingIndividualValuesModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPlans(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsPlansPlanModel>;
  public queryPlans(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsPlansPlanModel>>;
  public queryPlans(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsPlansPlanModel>>;
  public queryPlans(
    requestParameters?: SeasonsIncentiveAdminServiceQueryPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const seasonId = requestParameters?.seasonId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (seasonId !== undefined && seasonId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>seasonId, 'seasonId');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans`;
    return this.httpClient.request<SharedPageModelOfSeasonsPlansPlanModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPossibilitiesBudgetBuckets(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>;
  public queryPossibilitiesBudgetBuckets(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>>;
  public queryPossibilitiesBudgetBuckets(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>>;
  public queryPossibilitiesBudgetBuckets(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/component-settings`;
    return this.httpClient.request<Array<SeasonsBudgetComponentsBucketComponentsPossibilitiesModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySeasons(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSeasonsSeasonsSeasonModel>;
  public querySeasons(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSeasonsSeasonsSeasonModel>>;
  public querySeasons(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSeasonsSeasonsSeasonModel>>;
  public querySeasons(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const seasonType = requestParameters?.seasonType;
    const simulationState = requestParameters?.simulationState;
    const queryManagerEndDateAt = requestParameters?.queryManagerEndDateAt;
    const queryPartnerEndDateAt = requestParameters?.queryPartnerEndDateAt;
    const querySeasonType = requestParameters?.querySeasonType;
    const querySimulationState = requestParameters?.querySimulationState;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (seasonType) {
      seasonType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SeasonType');
      });
    }
    if (simulationState) {
      simulationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'SimulationState');
      });
    }
    if (queryManagerEndDateAt !== undefined && queryManagerEndDateAt !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryManagerEndDateAt,
        'Query.ManagerEndDateAt'
      );
    }
    if (queryPartnerEndDateAt !== undefined && queryPartnerEndDateAt !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>queryPartnerEndDateAt,
        'Query.PartnerEndDateAt'
      );
    }
    if (querySeasonType) {
      querySeasonType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.SeasonType');
      });
    }
    if (querySimulationState) {
      querySimulationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.SimulationState');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons`;
    return this.httpClient.request<SharedPageModelOfSeasonsSeasonsSeasonModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public querySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>;
  public querySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public querySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>>;
  public querySimulation(
    requestParameters?: SeasonsIncentiveAdminServiceQuerySimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling querySimulation.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations`;
    return this.httpClient.request<Array<PositionEvaluationSimulationsPositionEvaluationSimulationModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateCandidatePools(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfCandidatePoolRecalculationMetadata>;
  public recalculateCandidatePools(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public recalculateCandidatePools(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfCandidatePoolRecalculationMetadata>>;
  public recalculateCandidatePools(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools/recalculate`;
    return this.httpClient.request<TransactionStatusOfCandidatePoolRecalculationMetadata>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateParentSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateParentSettingsPopulationSimulationPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling recalculateParentSettingsPopulationSimulationPopulations.'
      );
    }
    const parentSettingId = requestParameters?.parentSettingId;
    if (parentSettingId === null || parentSettingId === undefined) {
      throw new Error(
        'Required parameter parentSettingId was null or undefined when calling recalculateParentSettingsPopulationSimulationPopulations.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation/${this.configuration.encodeParam({ name: 'parentSettingId', value: parentSettingId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<TransactionStatusOfSettingsPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculatePlanPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPlanPopulationRecalculationMetadata>;
  public recalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculatePlanPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public recalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculatePlanPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationRecalculationMetadata>>;
  public recalculatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculatePlanPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling recalculatePlanPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`;
    return this.httpClient.request<TransactionStatusOfPlanPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSettingsPopulationRecalculationMetadata>;
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSettingsPopulationRecalculationMetadata>>;
  public recalculateSettingsPopulationSimulationPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceRecalculateSettingsPopulationSimulationPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling recalculateSettingsPopulationSimulationPopulations.'
      );
    }
    const settingsType = requestParameters?.settingsType;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (settingsType !== undefined && settingsType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>settingsType, 'settingsType');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/population-recalculation`;
    return this.httpClient.request<TransactionStatusOfSettingsPopulationRecalculationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public savePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSavePlanPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPlanPopulationCreationMetadata>;
  public savePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSavePlanPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public savePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSavePlanPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPlanPopulationCreationMetadata>>;
  public savePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSavePlanPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling savePlanPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`;
    return this.httpClient.request<TransactionStatusOfPlanPopulationCreationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public saveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSaveSeasonPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfPopulationCreationMetadata>;
  public saveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSaveSeasonPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfPopulationCreationMetadata>>;
  public saveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSaveSeasonPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfPopulationCreationMetadata>>;
  public saveSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSaveSeasonPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling saveSeasonPopulations.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/save-population`;
    return this.httpClient.request<TransactionStatusOfPopulationCreationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulatePlanPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRemPopulationCreatedResultPagedDto>;
  public simulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulatePlanPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRemPopulationCreatedResultPagedDto>>;
  public simulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulatePlanPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRemPopulationCreatedResultPagedDto>>;
  public simulatePlanPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulatePlanPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling simulatePlanPopulations.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SeasonsRemPopulationCreatedResultPagedDto>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public simulateRuleInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateRuleInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    if (settingsId === null || settingsId === undefined) {
      throw new Error(
        'Required parameter settingsId was null or undefined when calling simulateRuleInformationVisibilitySettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling simulateRuleInformationVisibilitySettings.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public simulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateSeasonPopulationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsRemEmployeePopulationCreatedResultPagedDto>;
  public simulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateSeasonPopulationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsRemEmployeePopulationCreatedResultPagedDto>>;
  public simulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateSeasonPopulationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsRemEmployeePopulationCreatedResultPagedDto>>;
  public simulateSeasonPopulations(
    requestParameters?: SeasonsIncentiveAdminServiceSimulateSeasonPopulationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error('Required parameter seasonId was null or undefined when calling simulateSeasonPopulations.');
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const _export = requestParameters?._export;
    const sharedRuleEngineRuleSetModel = requestParameters?.sharedRuleEngineRuleSetModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (_export !== undefined && _export !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>_export, 'export');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulate-population`;
    return this.httpClient.request<SeasonsRemEmployeePopulationCreatedResultPagedDto>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: sharedRuleEngineRuleSetModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public unPrePublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPrePublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling unPrePublishSimulationPublications.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-pre-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public unPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfSimulationPublishMetadata>;
  public unPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfSimulationPublishMetadata>>;
  public unPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfSimulationPublishMetadata>>;
  public unPublishSimulationPublications(
    requestParameters?: SeasonsIncentiveAdminServiceUnPublishSimulationPublicationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling unPublishSimulationPublications.'
      );
    }
    const queryPositionName = requestParameters?.queryPositionName;
    const queryOrgCode = requestParameters?.queryOrgCode;
    const queryOrgCodeStartsWith = requestParameters?.queryOrgCodeStartsWith;
    const queryOrgLevel = requestParameters?.queryOrgLevel;
    const queryOrgSize = requestParameters?.queryOrgSize;
    const queryMercerJobCode = requestParameters?.queryMercerJobCode;
    const queryPositionClass = requestParameters?.queryPositionClass;
    const queryNewPositionClass = requestParameters?.queryNewPositionClass;
    const queryOriginalProposedPositionClass = requestParameters?.queryOriginalProposedPositionClass;
    const queryPositionType = requestParameters?.queryPositionType;
    const queryCountryIsoCode = requestParameters?.queryCountryIsoCode;
    const queryIncumbentGid = requestParameters?.queryIncumbentGid;
    const queryIncumbentFirstName = requestParameters?.queryIncumbentFirstName;
    const queryIncumbentLastName = requestParameters?.queryIncumbentLastName;
    const queryIncumbentCountryPlaceOfAction = requestParameters?.queryIncumbentCountryPlaceOfAction;
    const queryValidationManagerId = requestParameters?.queryValidationManagerId;
    const queryValidationManagerGid = requestParameters?.queryValidationManagerGid;
    const queryValidationManagerFirstName = requestParameters?.queryValidationManagerFirstName;
    const queryValidationManagerLastName = requestParameters?.queryValidationManagerLastName;
    const queryValidationState = requestParameters?.queryValidationState;
    const queryPlacementState = requestParameters?.queryPlacementState;
    const queryNewHireState = requestParameters?.queryNewHireState;
    const queryIsLocked = requestParameters?.queryIsLocked;
    const queryMercerJobFamily = requestParameters?.queryMercerJobFamily;
    const queryMercerJobSpecialization = requestParameters?.queryMercerJobSpecialization;
    const queryMercerJobSubFamily = requestParameters?.queryMercerJobSubFamily;
    const queryIncumbentAre = requestParameters?.queryIncumbentAre;
    const queryTag = requestParameters?.queryTag;
    const queryWasPromoted = requestParameters?.queryWasPromoted;
    const queryIsTransferred = requestParameters?.queryIsTransferred;
    const seasonsSimulationPublicationsUnPublishSimulationModel =
      requestParameters?.seasonsSimulationPublicationsUnPublishSimulationModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (queryPositionName) {
      queryPositionName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionName');
      });
    }
    if (queryOrgCode) {
      queryOrgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgCode');
      });
    }
    if (queryOrgCodeStartsWith) {
      queryOrgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OrgCodeStartsWith'
        );
      });
    }
    if (queryOrgLevel) {
      queryOrgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgLevel');
      });
    }
    if (queryOrgSize) {
      queryOrgSize.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.OrgSize');
      });
    }
    if (queryMercerJobCode) {
      queryMercerJobCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobCode');
      });
    }
    if (queryPositionClass) {
      queryPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionClass');
      });
    }
    if (queryNewPositionClass) {
      queryNewPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewPositionClass');
      });
    }
    if (queryOriginalProposedPositionClass) {
      queryOriginalProposedPositionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.OriginalProposedPositionClass'
        );
      });
    }
    if (queryPositionType) {
      queryPositionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PositionType');
      });
    }
    if (queryCountryIsoCode) {
      queryCountryIsoCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.CountryIsoCode');
      });
    }
    if (queryIncumbentGid) {
      queryIncumbentGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentGid');
      });
    }
    if (queryIncumbentFirstName) {
      queryIncumbentFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentFirstName'
        );
      });
    }
    if (queryIncumbentLastName) {
      queryIncumbentLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentLastName'
        );
      });
    }
    if (queryIncumbentCountryPlaceOfAction) {
      queryIncumbentCountryPlaceOfAction.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.IncumbentCountryPlaceOfAction'
        );
      });
    }
    if (queryValidationManagerId) {
      queryValidationManagerId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerId'
        );
      });
    }
    if (queryValidationManagerGid) {
      queryValidationManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerGid'
        );
      });
    }
    if (queryValidationManagerFirstName) {
      queryValidationManagerFirstName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerFirstName'
        );
      });
    }
    if (queryValidationManagerLastName) {
      queryValidationManagerLastName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.ValidationManagerLastName'
        );
      });
    }
    if (queryValidationState) {
      queryValidationState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.ValidationState');
      });
    }
    if (queryPlacementState) {
      queryPlacementState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.PlacementState');
      });
    }
    if (queryNewHireState) {
      queryNewHireState.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.NewHireState');
      });
    }
    if (queryIsLocked) {
      queryIsLocked.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsLocked');
      });
    }
    if (queryMercerJobFamily) {
      queryMercerJobFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.MercerJobFamily');
      });
    }
    if (queryMercerJobSpecialization) {
      queryMercerJobSpecialization.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSpecialization'
        );
      });
    }
    if (queryMercerJobSubFamily) {
      queryMercerJobSubFamily.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'Query.MercerJobSubFamily'
        );
      });
    }
    if (queryIncumbentAre) {
      queryIncumbentAre.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IncumbentAre');
      });
    }
    if (queryTag) {
      queryTag.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.Tag');
      });
    }
    if (queryWasPromoted) {
      queryWasPromoted.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.WasPromoted');
      });
    }
    if (queryIsTransferred) {
      queryIsTransferred.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Query.IsTransferred');
      });
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/un-publish`;
    return this.httpClient.request<TransactionStatusOfSimulationPublishMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationPublicationsUnPublishSimulationModel,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfImportStatusMetadata>;
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfImportStatusMetadata>>;
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfImportStatusMetadata>>;
  public updateBenchmarkValuesSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBenchmarkValuesSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel =
      requestParameters?.seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/snapshots/benchmarks`;
    return this.httpClient.request<TransactionStatusOfImportStatusMetadata>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSnapshotsUpdateSnapshotBenchmarkValuesModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBatchBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBatchBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling updateBucketComponentBatchBudgetComponents.'
      );
    }
    const seasonsBudgetComponentsUpdateManyBucketComponentsModel =
      requestParameters?.seasonsBudgetComponentsUpdateManyBucketComponentsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/budget-components/batch`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsUpdateManyBucketComponentsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetComponentsBucketComponentModificationResponseModel>;
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetComponentsBucketComponentModificationResponseModel>>;
  public updateBucketComponentBudgetComponents(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBucketComponentBudgetComponentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const budgetBucketId = requestParameters?.budgetBucketId;
    if (budgetBucketId === null || budgetBucketId === undefined) {
      throw new Error(
        'Required parameter budgetBucketId was null or undefined when calling updateBucketComponentBudgetComponents.'
      );
    }
    const seasonsBudgetComponentsUpdateBucketComponentModel =
      requestParameters?.seasonsBudgetComponentsUpdateBucketComponentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'budgetBucketId', value: budgetBucketId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/budget-components`;
    return this.httpClient.request<SeasonsBudgetComponentsBucketComponentModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetComponentsUpdateBucketComponentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBudgetBucketsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>;
  public updateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBudgetBucketsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBudgetBucketsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateBudgetBucketsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateBudgetBuckets.');
    }
    const seasonsBudgetBucketsUpdateBudgetBucketModel = requestParameters?.seasonsBudgetBucketsUpdateBudgetBucketModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetBucketsUpdateBudgetBucketModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateCandidatePoolsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsCandidatePoolsCandidatePoolModel>;
  public updateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateCandidatePoolsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsCandidatePoolsCandidatePoolModel>>;
  public updateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateCandidatePoolsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsCandidatePoolsCandidatePoolModel>>;
  public updateCandidatePools(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateCandidatePoolsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateCandidatePools.');
    }
    const seasonsCandidatePoolsUpdateCandidatePoolModel =
      requestParameters?.seasonsCandidatePoolsUpdateCandidatePoolModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/candidate-pools/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsCandidatePoolsCandidatePoolModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsCandidatePoolsUpdateCandidatePoolModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>;
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>>;
  public updateEmployeeSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateEmployeeSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel =
      requestParameters?.seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/employee-snapshots`;
    return this.httpClient.request<SeasonsEmployeeSnapshotsEmployeeSnapshotModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsEmployeeSnapshotsUpdateEmployeeSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>;
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>>;
  public updateInformationVisibilitySettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateInformationVisibilitySettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const settingsId = requestParameters?.settingsId;
    if (settingsId === null || settingsId === undefined) {
      throw new Error(
        'Required parameter settingsId was null or undefined when calling updateInformationVisibilitySettings.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling updateInformationVisibilitySettings.'
      );
    }
    const seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel =
      requestParameters?.seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/settings/information-visibility/${this.configuration.encodeParam({ name: 'settingsId', value: settingsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<MeritInformationVisibilitySettingsMeritInformationVisibilitySettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsInformationVisibilitySettingsUpdateInformationVisibilitySettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>;
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>>;
  public updateManyBudgetBuckets(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateManyBudgetBucketsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsBudgetBucketsUpdateManyBudgetBucketsModel =
      requestParameters?.seasonsBudgetBucketsUpdateManyBudgetBucketsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/budget-bucket/batch`;
    return this.httpClient.request<SeasonsBudgetBucketsBudgetBucketModificationResponseModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsBudgetBucketsUpdateManyBudgetBucketsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateMembers(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsMembersMemberModel>;
  public updateMembers(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsMembersMemberModel>>;
  public updateMembers(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsMembersMemberModel>>;
  public updateMembers(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsMembersUpdateMemberModel = requestParameters?.seasonsMembersUpdateMemberModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/members`;
    return this.httpClient.request<SeasonsMembersMemberModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsMembersUpdateMemberModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>;
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>>;
  public updateOrganisationInformationSnapshots(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateOrganisationInformationSnapshotsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateOrganisationInformationSnapshots.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateOrganisationInformationSnapshots.'
      );
    }
    const seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel =
      requestParameters?.seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/snapshots/organisations/information/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsOrganisationInformationSnapshotsOrganisationInformationSnapshotModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsOrganisationInformationSnapshotsUpdateOrganisationInformationSnapshotModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlanSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlanSettingsPlanSettingsModel>;
  public updatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlanSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlanSettingsPlanSettingsModel>>;
  public updatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlanSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlanSettingsPlanSettingsModel>>;
  public updatePlanSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlanSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePlanSettings.');
    }
    const planId = requestParameters?.planId;
    if (planId === null || planId === undefined) {
      throw new Error('Required parameter planId was null or undefined when calling updatePlanSettings.');
    }
    const seasonsPlanSettingsUpdatePlanSettingsModel = requestParameters?.seasonsPlanSettingsUpdatePlanSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/season-plans/${this.configuration.encodeParam({ name: 'planId', value: planId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/settings/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPlanSettingsPlanSettingsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPlanSettingsUpdatePlanSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePlans(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPlansPlanModel>;
  public updatePlans(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPlansPlanModel>>;
  public updatePlans(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPlansPlanModel>>;
  public updatePlans(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePlans.');
    }
    const seasonsPlansUpdatePlanModel = requestParameters?.seasonsPlansUpdatePlanModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsPlansPlanModel>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsPlansUpdatePlanModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsPublicationSettingsPublicationSettingsModel>;
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsPublicationSettingsPublicationSettingsModel>>;
  public updatePublicationSettingsPublicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdatePublicationSettingsPublicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updatePublicationSettingsPublicationSettings.'
      );
    }
    const seasonsPublicationSettingsUpdatePublicationSettingsModel =
      requestParameters?.seasonsPublicationSettingsUpdatePublicationSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/publication-settings`;
    return this.httpClient.request<SeasonsPublicationSettingsPublicationSettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsPublicationSettingsUpdatePublicationSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<MeritCommunicationSettingsMeritCommunicationSettingsModel>;
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<MeritCommunicationSettingsMeritCommunicationSettingsModel>>;
  public updateSeasonCommunicationSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonCommunicationSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateSeasonCommunicationSettings.'
      );
    }
    const seasonsCommunicationSettingsUpdateCommunicationSettingsModel =
      requestParameters?.seasonsCommunicationSettingsUpdateCommunicationSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/communication-settings`;
    return this.httpClient.request<MeritCommunicationSettingsMeritCommunicationSettingsModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsCommunicationSettingsUpdateCommunicationSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonSettingsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSettingsSeasonSettingsModel>;
  public updateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonSettingsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSettingsSeasonSettingsModel>>;
  public updateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonSettingsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSettingsSeasonSettingsModel>>;
  public updateSeasonSettings(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonSettingsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSettingsSetSeasonSettingsModel = requestParameters?.seasonsSettingsSetSeasonSettingsModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/settings`;
    return this.httpClient.request<SeasonsSettingsSeasonSettingsModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSettingsSetSeasonSettingsModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSeasonsSeasonModel>;
  public updateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSeasonsSeasonModel>>;
  public updateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSeasonsSeasonModel>>;
  public updateSeasons(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSeasonsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonsSeasonsUpdateSeasonModel = requestParameters?.seasonsSeasonsUpdateSeasonModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons`;
    return this.httpClient.request<SeasonsSeasonsSeasonModel>('put', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: seasonsSeasonsUpdateSeasonModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SeasonsSimulationsSimulationModel>;
  public updateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SeasonsSimulationsSimulationModel>>;
  public updateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SeasonsSimulationsSimulationModel>>;
  public updateSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error('Required parameter simulationId was null or undefined when calling updateSimulation.');
    }
    const seasonsSimulationsUpdateSimulationModel = requestParameters?.seasonsSimulationsUpdateSimulationModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<SeasonsSimulationsSimulationModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsUpdateSimulationModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfIMetadata>;
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfIMetadata>>;
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfIMetadata>>;
  public updateSimulationMembersSimulation(
    requestParameters?: SeasonsIncentiveAdminServiceUpdateSimulationMembersSimulationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const seasonId = requestParameters?.seasonId;
    if (seasonId === null || seasonId === undefined) {
      throw new Error(
        'Required parameter seasonId was null or undefined when calling updateSimulationMembersSimulation.'
      );
    }
    const simulationId = requestParameters?.simulationId;
    if (simulationId === null || simulationId === undefined) {
      throw new Error(
        'Required parameter simulationId was null or undefined when calling updateSimulationMembersSimulation.'
      );
    }
    const seasonsSimulationsUpdateSimulationMembersModel =
      requestParameters?.seasonsSimulationsUpdateSimulationMembersModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/admin/api/v1/incentive/seasons/${this.configuration.encodeParam({ name: 'seasonId', value: seasonId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/simulations/${this.configuration.encodeParam({ name: 'simulationId', value: simulationId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/update-members`;
    return this.httpClient.request<TransactionStatusOfIMetadata>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: seasonsSimulationsUpdateSimulationMembersModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
